
// before 20-5-2026
// import React, { useEffect, useState, useRef, useMemo } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation } from 'react-router-dom';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';
// import EmailIcon from '@mui/icons-material/Email';
// import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
// import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import RequestPageOutlinedIcon from '@mui/icons-material/RequestPageOutlined';
// import {SalesRequestData_Model} from './SalesRequestData_Model'
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Typography,
//   Box,
//   CircularProgress,
//   Chip,
//   Pagination,
//   Stack,
//   Card,
//   CardContent,
//   Avatar,
//   TextField,
//   MenuItem,
//   Button,
//   IconButton,
//   Checkbox,
//   Tooltip,
//   Skeleton,
//   useMediaQuery,
//   useTheme,
//   Select,
//   FormControl,
//   InputLabel,
//   Snackbar,
//   Alert,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Switch,
//   FormControlLabel,
//   Drawer,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   Divider,
//   Grid,
//   InputAdornment,
//   Badge,
//   LinearProgress,
//   Autocomplete,
//   FormHelperText,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import SearchIcon from '@mui/icons-material/Search';
// import SettingsIcon from '@mui/icons-material/Settings';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import PhoneIcon from '@mui/icons-material/Phone';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
// import CheckIcon from '@mui/icons-material/Check';
// import EditNoteIcon from '@mui/icons-material/EditNote';
// import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
// import SevereColdIcon from '@mui/icons-material/SevereCold';
// import ReplyIcon from '@mui/icons-material/Reply';
// import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import ClearIcon from '@mui/icons-material/Clear';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
// import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// import moment from 'moment';
// import 'moment-timezone';
// import io from 'socket.io-client';
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
// import LockIcon from '@mui/icons-material/Lock';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import { GetallLeads_data_With_Email2 } from '../../Redux/Actions/RoleData_Actions';
// import { Notify } from '../../Utility/Notify';
// import { Link } from 'react-router-dom';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';
// import { parsePhoneNumberFromString } from 'libphonenumber-js';
// import FileCopyIcon from '@mui/icons-material/FileCopy';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import { Get_sales_Login_For_Assign_Leads_To_histeamleader_Action } from '../../Redux/Actions/SalesAction';
// import PersonIcon from '@mui/icons-material/Person';
// import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
// import SaveIcon from '@mui/icons-material/Save';
// import { Error as ErrorIcon, Info as InfoIcon } from '@mui/icons-material';

// import {
//   UpdateClientAction,
//   UpdateClientActionToReaciveusertolead,
// } from '../../Redux/Actions/UsersAction';
// import { GetallProjectsdata } from '../../Redux/Actions/Projects_Action';
// import { ShowClientsActionsAdvanced } from '../../Pages/ShowClientsActionsAdvanced';
// import SalesQuickFilterModal from '../../Pages/SalesQuickFilterModal';
// const PhoneCell = React.memo(({ user, mode, isSmallScreen }) => {
//   const [isHovered, setIsHovered] = useState(false);
//   const [copied, setCopied] = useState(false);
//   const [phoneNumber, setPhoneNumber] = useState(user?.phone || '');

//   useEffect(() => {
//     setPhoneNumber(user?.phone || '');
//   }, [user?.phone]);

//   const handleMouseEnter = () => setIsHovered(true);
//   const handleMouseLeave = () => setIsHovered(false);

//   const getDisplayPhone = () => {
//     if (!phoneNumber || phoneNumber.trim() === '') return 'N/A';
//     if (isHovered) return phoneNumber;
//     return `${phoneNumber.substring(0, 5)}...`;
//   };

//   const handleWhatsAppClick = (e) => {
//     if (e) e.stopPropagation();
//     if (!phoneNumber || phoneNumber.trim() === '') {
//       Notify('error', 'No phone number available for WhatsApp', 'error');
//       return;
//     }

//     try {
//       const cleanPhone = phoneNumber.replace(/\D/g, '');
//       if (!cleanPhone || cleanPhone.length < 8) {
//         Notify('error', 'Invalid phone number format', 'error');
//         return;
//       }

//       const message = encodeURIComponent(
//         `Hello ${user?.name || ''}, I would like to discuss about our project.`,
//       );
//       const whatsappUrl = `https://wa.me/${cleanPhone}?text=${message}`;
//       window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
//       Notify('success', 'Opening WhatsApp...', 'success');
//     } catch (error) {
//       Notify('error', 'Failed to open WhatsApp', 'error');
//     }
//   };

//   const handlePhoneClick = (e) => {
//     if (e) e.stopPropagation();
//     if (!phoneNumber || phoneNumber.trim() === '') {
//       Notify('error', 'No phone number available for call', 'error');
//       return;
//     }

//     try {
//       const cleanPhone = phoneNumber.replace(/\D/g, '');
//       if (!cleanPhone || cleanPhone.length < 8) {
//         Notify('error', 'Invalid phone number format', 'error');
//         return;
//       }

//       const telUrl = `tel:${cleanPhone}`;
//       const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

//       if (isMobile) {
//         window.location.href = telUrl;
//       } else {
//         navigator.clipboard
//           .writeText(phoneNumber)
//           .then(() => Notify('success', 'Phone number copied for calling', 'success'))
//           .catch(() => {
//             const link = document.createElement('a');
//             link.href = telUrl;
//             link.style.display = 'none';
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//           });
//       }
//     } catch (error) {
//       Notify('error', 'Failed to initiate call', 'error');
//     }
//   };

//   const handleCopyClick = (e) => {
//     if (e) e.stopPropagation();
//     if (!phoneNumber || phoneNumber.trim() === '') {
//       Notify('error', 'No phone number to copy', 'error');
//       return;
//     }

//     const copyToClipboard = async () => {
//       try {
//         await navigator.clipboard.writeText(phoneNumber);
//         return true;
//       } catch (err) {
//         return false;
//       }
//     };

//     copyToClipboard()
//       .then((success) => {
//         if (success) {
//           setCopied(true);
//           Notify('success', 'Phone number copied to clipboard!', 'success');
//           setTimeout(() => setCopied(false), 2000);
//         } else {
//           Notify('error', 'Failed to copy phone number', 'error');
//         }
//       })
//       .catch((error) => Notify('error', 'Failed to copy phone number', 'error'));
//   };

//   const handleCellClick = (e) => {
//     e.stopPropagation();
//     handleCopyClick(e);
//   };

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         flexDirection: 'column',
//         gap: 0.5,
//         position: 'relative',
//         userSelect: 'none',
//         cursor: 'pointer',
//       }}
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//       onClick={handleCellClick}
//     >
//       <Box
//         sx={{
//           padding: '6px 8px',
//           borderRadius: '6px',
//           backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//           fontFamily: 'monospace',
//           fontWeight: '500',
//           minHeight: '36px',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           transition: 'all 0.3s ease',
//           border: '1px solid',
//           borderColor: copied
//             ? '#4caf50'
//             : mode === 'dark'
//               ? 'rgba(255,255,255,0.1)'
//               : 'rgba(0,0,0,0.1)',
//           '&:hover': {
//             backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
//             borderColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
//             transform: 'translateY(-1px)',
//             boxShadow:
//               mode === 'dark' ? '0 4px 12px rgba(0,0,0,0.2)' : '0 4px 12px rgba(0,0,0,0.08)',
//           },
//         }}
//       >
//         <Typography
//           variant="body2"
//           sx={{
//             color: copied ? '#4caf50' : mode === 'dark' ? '#ffffff' : '#333333',
//             fontWeight: copied ? '600' : '500',
//             fontSize: '13px',
//             letterSpacing: '0.5px',
//           }}
//         >
//           {getDisplayPhone()}
//         </Typography>

//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//           {!isHovered && !copied && (
//             <Tooltip title="Hover to reveal, click to copy">
//               <Box
//                 sx={{
//                   fontSize: '10px',
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '2px',
//                 }}
//               >
//                 <span>👁️</span>
//               </Box>
//             </Tooltip>
//           )}

//           {copied && (
//             <Tooltip title="Copied to clipboard!">
//               <CheckCircleIcon
//                 sx={{
//                   fontSize: '14px',
//                   color: '#4caf50',
//                 }}
//               />
//             </Tooltip>
//           )}
//         </Box>
//       </Box>

//       <Box
//         sx={{
//           display: 'flex',
//           gap: 0.5,
//           opacity: isHovered ? 1 : 0.6,
//           justifyContent: 'flex-start',
//           transition: 'opacity 0.3s ease',
//           padding: '2px',
//         }}
//       >
//         <Tooltip title="Open WhatsApp Chat">
//           <IconButton
//             size="small"
//             onClick={handleWhatsAppClick}
//             disabled={!phoneNumber || phoneNumber.trim() === ''}
//             sx={{
//               color: '#25D366',
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(37, 211, 102, 0.15)' : 'rgba(37, 211, 102, 0.1)',
//               '&:hover': {
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(37, 211, 102, 0.25)' : 'rgba(37, 211, 102, 0.2)',
//                 transform: 'scale(1.05)',
//               },
//               '&.Mui-disabled': {
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//               },
//               minWidth: '32px',
//               minHeight: '32px',
//               borderRadius: '8px',
//               transition: 'all 0.2s ease',
//             }}
//           >
//             <WhatsAppIcon sx={{ fontSize: '16px' }} />
//           </IconButton>
//         </Tooltip>

//         <Tooltip title="Make Phone Call">
//           <IconButton
//             size="small"
//             onClick={handlePhoneClick}
//             disabled={!phoneNumber || phoneNumber.trim() === ''}
//             sx={{
//               color: '#2196f3',
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(33, 150, 243, 0.15)' : 'rgba(33, 150, 243, 0.1)',
//               '&:hover': {
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(33, 150, 243, 0.25)' : 'rgba(33, 150, 243, 0.2)',
//                 transform: 'scale(1.05)',
//               },
//               '&.Mui-disabled': {
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//               },
//               minWidth: '32px',
//               minHeight: '32px',
//               borderRadius: '8px',
//               transition: 'all 0.2s ease',
//             }}
//           >
//             <PhoneIcon sx={{ fontSize: '16px' }} />
//           </IconButton>
//         </Tooltip>

//         <Tooltip title={copied ? 'Copied!' : 'Copy Phone Number'}>
//           <IconButton
//             size="small"
//             onClick={handleCopyClick}
//             disabled={!phoneNumber || phoneNumber.trim() === '' || copied}
//             sx={{
//               color: copied ? '#4caf50' : '#ff9800',
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(255, 152, 0, 0.15)' : 'rgba(255, 152, 0, 0.1)',
//               '&:hover': {
//                 backgroundColor: copied
//                   ? mode === 'dark'
//                     ? 'rgba(76, 175, 80, 0.25)'
//                     : 'rgba(76, 175, 80, 0.2)'
//                   : mode === 'dark'
//                     ? 'rgba(255, 152, 0, 0.25)'
//                     : 'rgba(255, 152, 0, 0.2)',
//                 transform: 'scale(1.05)',
//               },
//               '&.Mui-disabled': {
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//               },
//               minWidth: '32px',
//               minHeight: '32px',
//               borderRadius: '8px',
//               transition: 'all 0.2s ease',
//             }}
//           >
//             {copied ? (
//               <CheckCircleIcon sx={{ fontSize: '16px' }} />
//             ) : (
//               <ContentCopyIcon sx={{ fontSize: '16px' }} />
//             )}
//           </IconButton>
//         </Tooltip>
//       </Box>

//       {isHovered && (
//         <Tooltip
//           title={
//             <Box sx={{ p: 1 }}>
//               <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
//                 Phone Number Actions
//               </Typography>
//               <Typography variant="caption" sx={{ display: 'block', mb: 0.5 }}>
//                 📱 <strong>{phoneNumber || 'No phone number'}</strong>
//               </Typography>
//               <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 1 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <Box
//                     sx={{
//                       width: 20,
//                       height: 20,
//                       borderRadius: '50%',
//                       bgcolor: '#25D366',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                     }}
//                   >
//                     <WhatsAppIcon sx={{ fontSize: 12, color: 'white' }} />
//                   </Box>
//                   <Typography variant="caption">Open WhatsApp</Typography>
//                 </Box>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <Box
//                     sx={{
//                       width: 20,
//                       height: 20,
//                       borderRadius: '50%',
//                       bgcolor: '#2196f3',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                     }}
//                   >
//                     <PhoneIcon sx={{ fontSize: 12, color: 'white' }} />
//                   </Box>
//                   <Typography variant="caption">Make a call</Typography>
//                 </Box>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <Box
//                     sx={{
//                       width: 20,
//                       height: 20,
//                       borderRadius: '50%',
//                       bgcolor: '#ff9800',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                     }}
//                   >
//                     <FileCopyIcon sx={{ fontSize: 12, color: 'white' }} />
//                   </Box>
//                   <Typography variant="caption">Copy to clipboard</Typography>
//                 </Box>
//               </Box>
//             </Box>
//           }
//           open={isHovered}
//           arrow
//           placement="top"
//           PopperProps={{
//             sx: {
//               '& .MuiTooltip-tooltip': {
//                 backgroundColor: mode === 'dark' ? '#2d3748' : '#ffffff',
//                 color: mode === 'dark' ? '#ffffff' : '#333333',
//                 fontSize: '12px',
//                 padding: '12px',
//                 boxShadow:
//                   mode === 'dark' ? '0 8px 24px rgba(0,0,0,0.3)' : '0 8px 24px rgba(0,0,0,0.1)',
//                 border: '1px solid',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                 maxWidth: '280px',
//                 borderRadius: '12px',
//               },
//               '& .MuiTooltip-arrow': {
//                 color: mode === 'dark' ? '#2d3748' : '#ffffff',
//               },
//             },
//           }}
//         >
//           <Box
//             sx={{
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               pointerEvents: 'none',
//             }}
//           />
//         </Tooltip>
//       )}

//       {copied && (
//         <Snackbar
//           open={copied}
//           autoHideDuration={2000}
//           onClose={() => setCopied(false)}
//           anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//           sx={{
//             position: 'absolute',
//             bottom: -50,
//             left: '50%',
//             transform: 'translateX(-50%)',
//             '& .MuiSnackbarContent-root': {
//               backgroundColor: '#4caf50',
//               color: 'white',
//               borderRadius: '12px',
//               fontWeight: '500',
//               minWidth: '200px',
//             },
//           }}
//           message="Phone number copied to clipboard!"
//         />
//       )}
//     </Box>
//   );
// });

// const StageCell = React.memo(({ user, mode, isSmallScreen }) => {
//   const stageName = user.stage?.name || 'N/A';

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'flex-start',
//         gap: '4px',
//         textAlign: 'left',
//       }}
//     >
//       {user.stage?.name && (
//         <Box
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'flex-start',
//             gap: '5px',
//             fontSize: '13px',
//             fontWeight: '500',
//             color: mode === 'dark' ? '#fff' : '#333',
//             maxWidth: '160px',
//             whiteSpace: 'nowrap',
//             overflow: 'hidden',
//             textOverflow: 'ellipsis',
//           }}
//         >
//           {stageName === 'Done Deal' ? (
//             <span style={{ fontSize: '18px' }}>🎉</span>
//           ) : stageName === 'Fresh' ? (
//             <CheckIcon style={{ fontSize: '18px', color: '#4caf50' }} />
//           ) : stageName === 'Not Interested' ? (
//             <Box
//               sx={{
//                 fontSize: '18px',
//                 color: '#333',
//                 borderRadius: '50%',
//                 width: '20px',
//                 height: '20px',
//                 backgroundColor: mode === 'dark' ? '#666' : '#333',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//               }}
//             >
//               -
//             </Box>
//           ) : stageName === 'EOI' ? (
//             <EditNoteIcon style={{ color: '#9c27b0', fontSize: '18px' }} />
//           ) : stageName === 'Reservation' ? (
//             <AssignmentTurnedInIcon style={{ color: '#9c27b0', fontSize: '18px' }} />
//           ) : stageName === 'Pending' ? (
//             <SevereColdIcon style={{ color: '#9c27b0', fontSize: '18px' }} />
//           ) : stageName === 'Transfer' ? (
//             <TransferWithinAStationIcon style={{ color: 'red', fontSize: '18px' }} />
//           ) : (
//             <Box
//               sx={{
//                 backgroundColor:
//                   user.stagedateupdated && moment(user.stagedateupdated).isBefore(moment())
//                     ? '#CC5500'
//                     : 'royalblue',
//                 borderRadius: '50%',
//                 width: '20px',
//                 height: '20px',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 color: '#fff',
//               }}
//             >
//               {user.stagedateupdated && moment(user.stagedateupdated).isBefore(moment()) ? (
//                 <Box sx={{ fontSize: '14px' }} />
//               ) : (
//                 <Box sx={{ fontSize: '14px' }} />
//               )}
//             </Box>
//           )}

//           <Typography
//             variant="body2"
//             sx={{
//               color: mode === 'dark' ? '#fff' : '#333',
//               fontSize: '13px',
//               fontWeight: '500',
//             }}
//           >
//             {user.stage?.name}
//           </Typography>
//         </Box>
//       )}

//       {user.stagedateupdated && (
//         <Typography
//           variant="caption"
//           sx={{
//             fontSize: isSmallScreen ? '10px' : '11px',
//             color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#666',
//             textAlign: 'left',
//           }}
//         >
//           {moment(user.stagedateupdated).format(isSmallScreen ? 'DD/MM' : 'DD/MM/YYYY h:mm A')}
//         </Typography>
//       )}
//     </Box>
//   );
// });

// export const SalesAllLeadsCRMDATA = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
//   const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//   const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));
//   const location = useLocation();
//   const dispatch = useDispatch();

//   // States
//   const [userlogin, setUserlogin] = useState(null);
//   const [selectedLead, setSelectedLead] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [selectedLeads, setSelectedLeads] = useState([]);
//   const [searchQuery, setSearchQuery] = useState(
//     localStorage.getItem('searchsalesuserstorage') || '',
//   );
//   const [socket, setSocket] = useState(null);

//   // 🔥 إضافة state للـ sorting
//   const [sortConfig, setSortConfig] = useState({
//     key: null, // 'Creation_date' أو 'stage'
//     direction: 'ascending', // 'ascending' أو 'descending'
//   });

//   const [quickFilterOpen, setQuickFilterOpen] = useState(false);
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [goToPageDialog, setGoToPageDialog] = useState(false);
//   const [pageInput, setPageInput] = useState('');
//   const [navbarSearchTrigger, setNavbarSearchTrigger] = useState(0);
//   const [hasFilters, setHasFilters] = useState(false);

//   // 🔥 إضافة state لـ Edit Lead
//   const [loadingupdatelead, setloadingupdatelead] = useState(true);
//   const [loadingupdatelead2, setloadingupdatelead2] = useState(false);
//   const [leadnameupdate, setleadnameupdate] = useState('');
//   const [phonenumber2, setphonenumber2] = useState();
//   const [whatsappnumber, setwhatsappnumber] = useState();
//   const [error, setError] = useState('');
//   const [Errorphonenumber2, setErrorphonenumber2] = useState('');
//   const [whatsappnumbererror, setwhatsappnumbererror] = useState('');
//   const [showUpdateLead, setShowUpdateLead] = useState(false);
//   const [selectedLeadId, setSelectedLeadId] = useState(null);
//   const [projectupdatelead, setprojectupdatelead] = useState();

//   // 🔥 إضافة state للـ Receive Lead
//   const [showReceiveModal, setShowReceiveModal] = useState(false);
//   const [selectedLeadForReceive, setSelectedLeadForReceive] = useState(null);
//   const [receiveLoading, setReceiveLoading] = useState(false);

//   // 🔥 إضافة state للـ Confirmation Modal
//   const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
//   const [confirmAction, setConfirmAction] = useState(null);
//   const [confirmTitle, setConfirmTitle] = useState('');
//   const [confirmMessage, setConfirmMessage] = useState('');
//   const [clearHistory, setClearHistory] = useState(false);
//   const [loadingreturnleadstoteamleader, setloadingreturnleadstoteamleader] = useState(true);
//     const [requestDialogOpen, setRequestDialogOpen] = useState(false);

//   // Table Configuration
//   const defaultTableConfig = {
//     columns: [
//       { key: 'selection', label: '', visible: true, width: 60 },
//       { key: 'name', label: 'Name', visible: true, width: 180 },
//       { key: 'phone', label: 'Phone', visible: true, width: 140 },
//       { key: 'project', label: 'Project', visible: true, width: 150 },
//       { key: 'developer', label: 'Developer', visible: true, width: 120 },
//       { key: 'campaign', label: 'Campaign', visible: true, width: 150 },
//       { key: 'chanel', label: 'Channel', visible: false, width: 150 },
//       { key: 'stage', label: 'Stage', visible: true, width: 180 },
//       { key: 'Creation_date', label: 'Creation Date', visible: true, width: 180 },
//       { key: 'actions', label: 'Actions', visible: true, width: 200 },
//     ],
//     columnOrder: [
//       'selection',
//       'name',
//       'phone',
//       'project',
//       'developer',
//       'campaign',
//       'chanel',
//       'stage',
//       'Creation_date',
//       'actions',
//     ],
//     whiteHeaders: true,
//     dense: false,
//   };

//   const [tableConfig, setTableConfig] = useState(() => {
//     const savedConfig = localStorage.getItem('salesLeadsTableConfig');
//     return savedConfig ? JSON.parse(savedConfig) : defaultTableConfig;
//   });

//   const [tableSettingsOpen, setTableSettingsOpen] = useState(false);

//   // Get User Data
//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem('user'));
//     if (user) {
//       setUserlogin(user);
//     }
//   }, []);

//   // Save table config to localStorage
//   useEffect(() => {
//     localStorage.setItem('salesLeadsTableConfig', JSON.stringify(tableConfig));
//   }, [tableConfig]);

//   const leadsFromRedux = useSelector((state) => state.AllRoleData.LeadsForSales);

//   // 🔥 دالة جلب البيانات
//   const getallleadsforsales = async (
//     page = 1,
//     limit = itemsPerPage,
//     searchTerm = searchQuery,
//     filters = appliedFilters,
//     isQuickFilter = false,
//   ) => {
//     if (!userlogin?.data?.email) return;

//     setLoading(true);
//     try {
//       console.log('🚀 START getallleadsforsales');

//       let processedSearchTerm = searchTerm;

//       if (searchTerm && searchTerm.includes('+')) {
//         processedSearchTerm = searchTerm.replace('+', '');
//       }

//       let queryString = `page=${page}&limit=${limit}`;
//       queryString += `&email=${encodeURIComponent(userlogin.data.email)}`;
//       if (processedSearchTerm && processedSearchTerm.trim() !== '') {
//         queryString += `&keyword=${encodeURIComponent(processedSearchTerm.trim())}`;
//       }

//       const searchParams = new URLSearchParams(location.search);
//       const stage = searchParams.get('stage');
//       if (stage) {
//         queryString += `&stage=${stage}`;
//       }
//       queryString += `&data=false&transferefromdata=false`;

//       if (Object.keys(filters).length > 0) {
//         console.log('🎯 Processing quick filters:', filters);

//         if (filters.stage && filters.stage.length > 0) {
//           filters.stage.forEach((stage) => {
//             if (stage && stage._id) {
//               queryString += `&stage=${stage._id}`;
//             } else if (stage && typeof stage === 'string') {
//               queryString += `&stage=${encodeURIComponent(stage)}`;
//             }
//           });
//         }

//         if (filters.project && filters.project.length > 0) {
//           filters.project.forEach((project) => {
//             if (project && project._id) {
//               queryString += `&project=${project._id}`;
//             } else if (project && typeof project === 'string') {
//               queryString += `&project=${encodeURIComponent(project)}`;
//             }
//           });
//         }

//         if (filters.developer && filters.developer.length > 0) {
//           filters.developer.forEach((developer) => {
//             if (developer && developer._id) {
//               queryString += `&developer=${developer._id}`;
//             } else if (developer && typeof developer === 'string') {
//               queryString += `&developer=${encodeURIComponent(developer)}`;
//             }
//           });
//         }

//         if (filters.chanel && filters.chanel.length > 0) {
//           filters.chanel.forEach((chanel) => {
//             if (chanel && chanel._id) {
//               queryString += `&channel=${chanel._id}`;
//             } else if (chanel && typeof chanel === 'string') {
//               queryString += `&channel=${encodeURIComponent(chanel)}`;
//             }
//           });
//         }

//         if (filters.campaign && filters.campaign.length > 0) {
//           filters.campaign.forEach((campaign) => {
//             if (campaign && campaign._id) {
//               queryString += `&campaign=${campaign._id}`;
//             } else if (campaign && typeof campaign === 'string') {
//               queryString += `&campaign=${encodeURIComponent(campaign)}`;
//             }
//           });
//         }

//         if (filters.createdAt) {
//           if (filters.createdAt.from) {
//             queryString += `&createdFrom=${encodeURIComponent(filters.createdAt.from)}`;
//           }
//           if (filters.createdAt.to) {
//             queryString += `&createdTo=${encodeURIComponent(filters.createdAt.to)}`;
//           }
//         }

//         if (filters.stagedateupdated) {
//           if (filters.stagedateupdated.from) {
//             queryString += `&stageDateFrom=${encodeURIComponent(filters.stagedateupdated.from)}`;
//           }
//           if (filters.stagedateupdated.to) {
//             queryString += `&stageDateTo=${encodeURIComponent(filters.stagedateupdated.to)}`;
//           }
//         }
//       }

//       await dispatch(GetallLeads_data_With_Email2(userlogin.data.email, queryString));

//       console.log('✅ Data fetch completed');
//     } catch (error) {
//       console.error('❌ Error fetching leads:', error);
//       Notify('error', 'Failed to load leads', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     console.log('🔄 Component state update:', {
//       currentPage,
//       itemsPerPage,
//       searchQuery,
//       sortConfig,
//       appliedFilters: Object.keys(appliedFilters).length,
//       navbarSearchTrigger,
//     });
//   }, [currentPage, itemsPerPage, searchQuery, sortConfig, appliedFilters, navbarSearchTrigger]);

//   // Initial Load
//   useEffect(() => {
//     if (userlogin?.data?.email) {
//       getallleadsforsales();
//     }
//   }, [userlogin]);

//   // Listen for navbar search updates
//   useEffect(() => {
//     const handleNavbarSearchUpdate = () => {
//       const savedSearch = localStorage.getItem('searchsalesuserstorage') || '';
//       console.log('🔄 Navbar search updated in localStorage:', savedSearch);

//       setSearchQuery(savedSearch);
//       setNavbarSearchTrigger((prev) => prev + 1);
//       setCurrentPage(1);

//       if (userlogin?.data?.email) {
//         console.log('🔄 Triggering data refresh from navbar search');
//         getallleadsforsales(1, itemsPerPage, savedSearch);
//       }
//     };

//     window.addEventListener('searchsalesuserstorageUpdate', handleNavbarSearchUpdate);

//     const interval = setInterval(() => {
//       const currentSearch = localStorage.getItem('searchsalesuserstorage') || '';
//       if (currentSearch !== searchQuery) {
//         console.log('🔄 Navbar search changed via localStorage:', currentSearch);
//         handleNavbarSearchUpdate();
//       }
//     }, 1000);

//     return () => {
//       window.removeEventListener('searchsalesuserstorageUpdate', handleNavbarSearchUpdate);
//       clearInterval(interval);
//     };
//   }, [userlogin, itemsPerPage, searchQuery]);

//   // Handle search and filters with debounce
//   useEffect(() => {
//     const searchTimer = setTimeout(() => {
//       if (searchQuery || Object.keys(appliedFilters).length > 0) {
//         setCurrentPage(1);
//         getallleadsforsales(1, itemsPerPage, searchQuery, appliedFilters);
//       }
//     }, 500);

//     return () => clearTimeout(searchTimer);
//   }, [searchQuery, appliedFilters, navbarSearchTrigger]);

//   // Update current page when backend returns pagination
//   useEffect(() => {
//     const pagination = getPagination();
//     if (pagination && pagination.currentPage) {
//       console.log('🔄 Updating current page from backend:', pagination.currentPage);
//       setCurrentPage(pagination.currentPage);
//     }
//   }, [leadsFromRedux]);

//   // Get Data from Redux
//   console.log('Leads data from Redux:', leadsFromRedux);
//   console.log('Is Array?', Array.isArray(leadsFromRedux));
//   console.log('Data structure:', leadsFromRedux);

//   // 🔥 دالة مساعدة للحصول على الـ leads array
//   const getLeadsArray = () => {
//     if (!leadsFromRedux) return [];

//     console.log('🔍 Parsing leads data:', leadsFromRedux);

//     if (
//       leadsFromRedux.data &&
//       leadsFromRedux.data.data &&
//       Array.isArray(leadsFromRedux.data.data)
//     ) {
//       console.log('✅ Found leads in data.data');
//       return leadsFromRedux.data.data;
//     }

//     if (leadsFromRedux.data && Array.isArray(leadsFromRedux.data)) {
//       console.log('✅ Found leads in data');
//       return leadsFromRedux.data;
//     }

//     if (Array.isArray(leadsFromRedux)) {
//       console.log('✅ Found leads in root');
//       return leadsFromRedux;
//     }

//     console.log('❌ No leads array found');
//     return [];
//   };

//   // 🔥 دالة مساعدة للحصول على الـ pagination
//   const getPagination = () => {
//     if (!leadsFromRedux) return null;

//     console.log('🔍 Checking pagination in:', leadsFromRedux);

//     if (leadsFromRedux.data && leadsFromRedux.data.pagination) {
//       console.log('📊 Found pagination in data.pagination');
//       return leadsFromRedux.data.pagination;
//     }

//     if (leadsFromRedux.pagination) {
//       console.log('📊 Found pagination in root');
//       return leadsFromRedux.pagination;
//     }

//     console.log('❌ No pagination found');
//     return null;
//   };

//   // 🔥 دالة الـ Sorting المحلي
//   const sortedLeads = useMemo(() => {
//     const leadsArray = getLeadsArray();
//     if (!leadsArray.length || !sortConfig.key) return leadsArray;

//     console.log('🔄 Sorting leads by:', sortConfig.key, 'direction:', sortConfig.direction);

//     return [...leadsArray].sort((a, b) => {
//       // الحصول على القيمة من الـ lead
//       const getValue = (lead) => {
//         switch (sortConfig.key) {
//           case 'Creation_date':
//             return lead.date ? new Date(lead.date) : new Date(0);
//           case 'stage':
//             return lead.stagedateupdated ? new Date(lead.stagedateupdated) : new Date(0);
//           default:
//             return 0;
//         }
//       };

//       const valueA = getValue(a);
//       const valueB = getValue(b);

//       // المقارنة
//       if (valueA < valueB) {
//         return sortConfig.direction === 'ascending' ? -1 : 1;
//       }
//       if (valueA > valueB) {
//         return sortConfig.direction === 'ascending' ? 1 : -1;
//       }
//       return 0;
//     });
//   }, [leadsFromRedux, sortConfig]);

//   // البيانات المعروضة (مرتبة أو غير مرتبة)
//   const displayLeads = sortConfig.key ? sortedLeads : getLeadsArray();

//   const getallprojects = async () => {
//     await dispatch(GetallProjectsdata());
//   };

//   useEffect(() => {
//     getallprojects();
//   }, []);

//   const resproject = useSelector((state) => state.AllProjects.Projects);
//   let projectarray = Array.isArray(resproject?.data) ? resproject.data : [];

//   // Get pagination
//   const pagination = getPagination();

//   // Selection Functions
//   const handleSelectLead = (leadId, event) => {
//     if (event) {
//       event.stopPropagation();
//     }
//     setSelectedLeads((prev) =>
//       prev.includes(leadId) ? prev.filter((id) => id !== leadId) : [...prev, leadId],
//     );
//   };

//   const handleSelectAll = (event) => {
//     if (event) {
//       event.stopPropagation();
//     }
//     if (selectedLeads.length === displayLeads.length) {
//       setSelectedLeads([]);
//     } else {
//       const allIds = displayLeads.map((lead) => lead._id) || [];
//       setSelectedLeads(allIds);
//     }
//   };

//   // 🔥 دالة الـ Sorting
//   const handleSort = (key) => {
//     console.log('🎯 Requesting sort for key:', key);

//     setSortConfig((prevConfig) => {
//       // إذا كان نفس العمود، غير الاتجاه
//       if (prevConfig.key === key) {
//         const newDirection = prevConfig.direction === 'ascending' ? 'descending' : 'ascending';
//         return {
//           key,
//           direction: newDirection,
//         };
//       }

//       // إذا كان عمود مختلف، ابدأ تصاعدياً
//       return {
//         key,
//         direction: 'ascending',
//       };
//     });

//     // إظهار إشعار
//     const directionText =
//       sortConfig.key === key
//         ? sortConfig.direction === 'ascending'
//           ? 'Descending'
//           : 'Ascending'
//         : 'Ascending';

//     Notify(
//       'info',
//       `Sorted by ${key === 'Creation_date' ? 'Creation Date' : 'Stage Date'} (${directionText})`,
//       'info',
//     );
//   };

//   // 🔥 دالة للـ Sort السريع
//   const handleQuickSort = (type) => {
//     if (type === 'newest') {
//       setSortConfig({
//         key: 'Creation_date',
//         direction: 'descending',
//       });
//       Notify('info', 'Showing newest leads first', 'info');
//     } else if (type === 'oldest') {
//       setSortConfig({
//         key: 'Creation_date',
//         direction: 'ascending',
//       });
//       Notify('info', 'Showing oldest leads first', 'info');
//     } else if (type === 'recentStage') {
//       setSortConfig({
//         key: 'stage',
//         direction: 'descending',
//       });
//       Notify('info', 'Showing recent stage updates first', 'info');
//     }
//   };

//   // 🔥 Pagination Functions
//   const handlePageChange = (event, value) => {
//     console.log('📄 Changing to page:', value);
//     setCurrentPage(value);

//     setTimeout(() => {
//       getallleadsforsales(value, itemsPerPage, searchQuery);
//     }, 0);
//   };

//   const handleItemsPerPageChange = (event) => {
//     const newLimit = event.target.value;
//     console.log('🔄 Changing items per page from', itemsPerPage, 'to', newLimit);
//     setItemsPerPage(newLimit);
//     setCurrentPage(1);

//     setTimeout(() => {
//       getallleadsforsales(1, newLimit, searchQuery);
//     }, 0);
//   };

//   // Go to page dialog handlers
//   const handleOpenGoToPage = () => {
//     setPageInput(currentPage.toString());
//     setGoToPageDialog(true);
//   };

//   const handleCloseGoToPage = () => {
//     setGoToPageDialog(false);
//   };

//   const handleGoToPage = () => {
//     const pageNum = parseInt(pageInput);
//     const totalPages = pagination?.NumberOfPages || 1;

//     if (pageNum >= 1 && pageNum <= totalPages) {
//       setCurrentPage(pageNum);
//       getallleadsforsales(pageNum, itemsPerPage, searchQuery);
//       handleCloseGoToPage();
//     }
//   };

//   // Quick Filter Functions
//   const handleQuickFilterOpen = () => setQuickFilterOpen(true);
//   const handleQuickFilterClose = () => setQuickFilterOpen(false);

//   const handleApplyFilters = (filters, queryString) => {
//     console.log('🎯 Applying filters from modal:', filters);
//     console.log('🔗 Query string:', queryString);

//     setAppliedFilters(filters);

//     const hasActiveFilters = Object.keys(filters).some((key) => {
//       if (Array.isArray(filters[key])) {
//         return filters[key].length > 0;
//       } else if (typeof filters[key] === 'object') {
//         return filters[key] && (filters[key].from || filters[key].to);
//       }
//       return false;
//     });

//     setHasFilters(hasActiveFilters);

//     setCurrentPage(1);

//     setTimeout(() => {
//       getallleadsforsales(1, itemsPerPage, searchQuery, filters, true);
//     }, 100);
//   };

//   // 🔥 دالة مسح الـ filters
//   const handleClearAllFilters = () => {
//     console.log('🧹 Clearing all filters');

//     setAppliedFilters({});
//     setHasFilters(false);
//     setSearchQuery('');
//     localStorage.removeItem('searchsalesuserstorage');
//     setCurrentPage(1);

//     setTimeout(() => {
//       getallleadsforsales(1, itemsPerPage);
//     }, 100);

//     Notify('success', 'All filters cleared', 'success');
//   };

//   const getInitials = (name) => {
//     if (!name || name.trim() === '') return '??';

//     const nameParts = name.trim().split(' ');
//     if (nameParts.length === 1) {
//       return nameParts[0].substring(0, 2).toUpperCase();
//     }

//     return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
//   };

//   // 🔥 دالة فتح Receive Modal
//   const handleOpenReceiveModal = (lead) => {
//     setSelectedLeadForReceive(lead);
//     setShowReceiveModal(true);
//   };

//   const handleCloseReceiveModal = () => {
//     setShowReceiveModal(false);
//     setSelectedLeadForReceive(null);
//   };

//   // 🔥 دالة Receive Lead
//   const handleReceiveLead = async () => {
//     if (!selectedLeadForReceive) return;

//     setReceiveLoading(true);
//     try {
//       const currentPageBefore = currentPage;
//       const currentItemsPerPage = itemsPerPage;

//       await dispatch(
//         UpdateClientActionToReaciveusertolead(selectedLeadForReceive._id, {
//           assign: false,
//         }),
//       );

//       Notify('success', '✅ Successfully received lead', 'success');
//       handleCloseReceiveModal();

//       setTimeout(() => {
//         getallleadsforsales(currentPageBefore, currentItemsPerPage, searchQuery, appliedFilters);
//       }, 100);
//     } catch (error) {
//       console.error('❌ Error receiving lead:', error);
//       Notify('error', 'Failed to receive lead', 'error');
//       handleCloseReceiveModal();
//     } finally {
//       setReceiveLoading(false);
//     }
//   };

//   // 🔥 دالة فتح Confirmation Modal
//   const openConfirmationModal = (action, title, message) => {
//     console.log('🔓 Opening confirmation modal');
//     console.log('📝 Title:', title);
//     console.log('📄 Message:', message);

//     setConfirmAction(() => action);
//     setConfirmTitle(title);
//     setConfirmMessage(message);
//     setConfirmDialogOpen(true);
//   };

//   // 🔥 دالة Return to Team Leader
//   const handleReturnToTeamLeader = () => {
//     console.log('🎯 handleReturnToTeamLeader called');
//     console.log('📊 selectedLeads:', selectedLeads);

//     if (selectedLeads.length === 0) {
//       Notify('warning', 'Please select at least one lead to return', 'warning');
//       return;
//     }

//     openConfirmationModal(
//       async () => {
//         console.log('✅ Confirmed - executing return');
//         await executeReturnToTeamLeader();
//       },
//       'Return Leads to Team Leader',
//       `Are you sure you want to return ${selectedLeads.length} selected lead(s) to your Team Leader?\n\nThis action cannot be undone.`,
//     );
//   };

//   // 🔥 دالة التنفيذ الفعلية
//   const executeReturnToTeamLeader = async () => {
//     console.log('🔄 Starting executeReturnToTeamLeader');
//     setloadingreturnleadstoteamleader(true);

//     try {
//       console.log('📤 Dispatching action...');

//       await dispatch(
//         Get_sales_Login_For_Assign_Leads_To_histeamleader_Action(selectedLeads, clearHistory),
//       );

//       console.log('✅ Action dispatched successfully');
//       await getallleadsforsales();
//       setConfirmDialogOpen(false);
//     } catch (error) {
//       console.error('❌ Error in executeReturnToTeamLeader:', error);
//       Notify('error', 'Failed to return leads to team leader', 'error');
//     } finally {
//       setloadingreturnleadstoteamleader(false);
//     }
//   };

//   const salesdata = useSelector((state) => state.AllSales.sales_Assign_Leads_To_hisTeamLeader);

//   useEffect(() => {
//     if (loadingreturnleadstoteamleader === false) {
//       if (salesdata && salesdata.status === 200) {
//         Notify('success', 'Successfully Confirmed Return Lead To Your TeamLeader', 'success');
//         setSelectedLeads([]);
//       } else {
//         Notify('error', 'Failed to update', 'error');
//       }
//     }
//   }, [loadingreturnleadstoteamleader]);

//   // 🔥 Edit Lead Functions
//   const handleleadnameupdatechange = (e) => {
//     setleadnameupdate(e.target.value);
//   };

//   const handleShowUpdateLead = (lead) => {
//     console.log('🔍 Opening modal for lead:', lead);

//     setSelectedLeadId(lead?._id);

//     if (lead) {
//       console.log('📝 Setting lead data:', {
//         name: lead.name,
//         phonenumber2: lead.phonenumber2,
//         whatsappnumber: lead.whatsappnumber,
//         project: lead.project,
//       });

//       setleadnameupdate(lead.name || '');
//       setphonenumber2(lead.phonenumber2 || '');
//       setwhatsappnumber(lead.whatsappnumber || '');

//       if (lead.project) {
//         console.log('🏢 Lead project:', lead.project);

//         if (lead.project._id) {
//           const foundProject = resproject?.data?.find((p) => p._id === lead.project._id);
//           setprojectupdatelead(foundProject || lead.project);
//           console.log('✅ Found project by _id:', foundProject);
//         } else if (typeof lead.project === 'string') {
//           const foundProject = resproject?.data?.find((p) => p._id === lead.project);
//           setprojectupdatelead(foundProject);
//           console.log('✅ Found project by string ID:', foundProject);
//         } else if (lead.project.name) {
//           const foundProject = resproject?.data?.find((p) => p.name === lead.project.name);
//           setprojectupdatelead(foundProject || lead.project);
//           console.log('✅ Found project by name:', foundProject);
//         }
//       } else {
//         setprojectupdatelead(null);
//         console.log('❌ No project found for lead');
//       }
//     }

//     setShowUpdateLead(true);

//     setTimeout(() => {
//       console.log('📊 Current form values after setting:', {
//         leadnameupdate: leadnameupdate,
//         phonenumber2: phonenumber2,
//         whatsappnumber: whatsappnumber,
//         projectupdatelead: projectupdatelead,
//       });
//     }, 100);
//   };

//   const handleCloseUpdateLead = () => {
//     setShowUpdateLead(false);
//     setSelectedLeadId(null);
//     setphonenumber2();
//     setleadnameupdate();
//     setwhatsappnumber();
//   };

//   const handlePhone2Change = (newValue) => {
//     setphonenumber2(newValue);
//     setErrorphonenumber2('');
//   };

//   const handlewhatsappnumberChange = (newValue) => {
//     setwhatsappnumber(newValue);
//     setwhatsappnumbererror('');
//   };

//   const handleBlurphonenumber2 = () => {
//     const phoneNumber2 = parsePhoneNumberFromString(`+${phonenumber2}`);
//     if (phoneNumber2 && phoneNumber2.isValid()) {
//       setErrorphonenumber2('');
//     } else {
//       setErrorphonenumber2('Please enter a valid phone number 2');
//     }
//   };

//   const handleBlurwhatsappnumber = () => {
//     const whatsappNumber = parsePhoneNumberFromString(`+${whatsappnumber}`);
//     if (whatsappNumber && whatsappNumber.isValid()) {
//       setwhatsappnumbererror('');
//     } else {
//       setwhatsappnumbererror('Please enter a valid whatsapp number ');
//     }
//   };

//   const onprojectupdateleadchange = (newValue) => {
//     setprojectupdatelead(newValue);
//   };

//   const handleUpdateLead = async (e) => {
//     e.preventDefault();

//     if (!selectedLeadId) {
//       Notify('error', '⚠️ Lead Id Not Selected', 'error');
//       return;
//     }
//     if (leadnameupdate === '') {
//       Notify('error', '⚠️ Lead Name is Required', 'error');
//       return;
//     }

//     if (projectupdatelead === '') {
//       Notify('error', '⚠️ Project is Required ', 'error');
//       return;
//     }

//     try {
//       setloadingupdatelead(true);
//       setloadingupdatelead2(true);
//       await dispatch(
//         UpdateClientAction(selectedLeadId, {
//           name: leadnameupdate,
//           phonenumber2,
//           whatsappnumber,
//           project: projectupdatelead,
//         }),
//       );
//       setloadingupdatelead(false);
//       setloadingupdatelead2(false);
//       handleCloseUpdateLead();
//     } catch (err) {
//       console.error('❌ Error updating lead:', err);
//       Notify('error', '❌ حدث خطأ أثناء تحديث البيانات', 'error');
//     }
//   };

//   const resupdatelead = useSelector((state) => state.Allusers.Get_users);

//   useEffect(() => {
//     if (loadingupdatelead === false) {
//       if (resupdatelead && resupdatelead?.status === 200) {
//         Notify('success', '✅ Lead Updated Succesfully', 'success');
//         getallleadsforsales();
//       } else {
//         Notify('error', 'Error accourd While Update Lead Data ', 'error');
//         return;
//       }
//     }
//   }, [loadingupdatelead]);

//   // Handle local search change
//   const handleLocalSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchQuery(value);
//     localStorage.setItem('searchsalesuserstorage', value);
//   };

//   // Handle clear search
//   const handleClearSearch = () => {
//     setSearchQuery('');
//     localStorage.removeItem('searchsalesuserstorage');
//     setCurrentPage(1);
//     getallleadsforsales(1, itemsPerPage);
//   };

//   // Table Settings Functions
//   const toggleColumnVisibility = (columnKey) => {
//     setTableConfig((prev) => ({
//       ...prev,
//       columns: prev.columns.map((col) =>
//         col.key === columnKey ? { ...col, visible: !col.visible } : col,
//       ),
//     }));
//   };

//   const resetTableConfig = () => {
//     setTableConfig(defaultTableConfig);
//   };

//   const toggleDenseMode = () => {
//     setTableConfig((prev) => ({
//       ...prev,
//       dense: !prev.dense,
//     }));
//   };

//   // Drag and Drop handler
//   const handleDragEnd = (result) => {
//     if (!result.destination) return;

//     const items = Array.from(tableConfig.columnOrder);
//     const [reorderedItem] = items.splice(result.source.index, 1);
//     items.splice(result.destination.index, 0, reorderedItem);

//     setTableConfig((prev) => ({
//       ...prev,
//       columnOrder: items,
//     }));
//   };

//   // Update column width
//   const updateColumnWidth = (columnKey, newWidth) => {
//     const minWidth = 60;
//     const maxWidth = 400;

//     const width = Math.min(Math.max(newWidth, minWidth), maxWidth);

//     setTableConfig((prev) => ({
//       ...prev,
//       columns: prev.columns.map((col) => (col.key === columnKey ? { ...col, width } : col)),
//     }));
//   };

//   // Render Cell Content
//   const renderCell = (col, lead) => {
//     switch (col.key) {
//       case 'selection':
//         return (
//           <Box onClick={(e) => e.stopPropagation()}>
//             <Checkbox
//               checked={selectedLeads.includes(lead._id)}
//               onChange={(e) => handleSelectLead(lead._id, e)}
//               onClick={(e) => e.stopPropagation()}
//               sx={{
//                 color: mode === 'dark' ? '#fff' : '#000',
//                 '& .MuiSvgIcon-root': {
//                   fontSize: tableConfig.dense ? 20 : 24,
//                 },
//               }}
//             />
//           </Box>
//         );

//       case 'name':
//         return (
//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: 2,
//               cursor: 'pointer',
//               '&:hover': {
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//                 borderRadius: '8px',
//                 padding: '8px',
//                 margin: '-8px',
//                 transition: 'all 0.2s ease',
//               },
//             }}
//             onClick={() => {
//               console.log('👤 Clicked on lead:', lead);
//               setSelectedLead(lead);
//             }}
//           >
//             <Avatar
//               sx={{
//                 bgcolor: mode === 'dark' ? 'secondary.main' : 'primary.main',
//                 width: 40,
//                 height: 40,
//                 fontSize: '14px',
//                 fontWeight: 'bold',
//               }}
//             >
//               {getInitials(lead.name)}
//             </Avatar>
//             <Box sx={{ flex: 1 }}>
//               <Typography variant="body1" fontWeight="medium">
//                 {lead.name || 'N/A'}
//               </Typography>
//               <Typography variant="caption" color="text.secondary">
//                 {lead.email || 'No email'}
//               </Typography>
//               {lead.companyName && (
//                 <Typography
//                   variant="caption"
//                   color="text.secondary"
//                   sx={{ display: 'block', mt: 0.5 }}
//                 >
//                   🏢 {lead.companyName}
//                 </Typography>
//               )}
//             </Box>
//           </Box>
//         );

//       case 'phone':
//         return <PhoneCell user={lead} mode={mode} isSmallScreen={isSmallScreen} />;

//       case 'project':
//         return (
//           <Typography variant="body2" fontWeight="medium">
//             {lead.project?.name || 'N/A'}
//           </Typography>
//         );

//       case 'developer':
//         return (
//           <Typography variant="body2">
//             {lead.developer?.name || lead.project?.developer?.name || 'N/A'}
//           </Typography>
//         );

//       // case 'campaign':
//       //   return (
//       //     <Typography variant="body2">
//       //       {lead.campaign?.CampainName || 'N/A'}
//       //     </Typography>
//       //   );

//       case 'campaign':
//         return (
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
//             {/* Campaign Name */}
//             <Typography
//               variant="body2"
//               sx={{
//                 fontWeight: lead.campaign?.redirectLink ? '500' : 'normal',
//                 color: lead.campaign?.redirectLink ? '#1976d2' : 'inherit',
//               }}
//             >
//               {lead.campaign?.CampainName || 'N/A'}
//             </Typography>

//             {/* Icons Row - Only shown if there's a redirect link */}
//             {lead.campaign?.redirectLink && (
//               <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
//                 <Tooltip title="Copy Link">
//                   <IconButton
//                     size="small"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       navigator.clipboard.writeText(lead.campaign.redirectLink);
//                       Notify('success', 'Link copied', 'success');
//                     }}
//                     sx={{
//                       padding: '2px',
//                       minWidth: '20px',
//                       height: '20px',
//                       color: '#666',
//                       '&:hover': {
//                         color: '#1976d2',
//                       },
//                     }}
//                   >
//                     <ContentCopyIcon sx={{ fontSize: '14px' }} />
//                   </IconButton>
//                 </Tooltip>

//                 <Tooltip title="Open Link">
//                   <IconButton
//                     size="small"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       window.open(lead.campaign.redirectLink, '_blank', 'noopener,noreferrer');
//                     }}
//                     sx={{
//                       padding: '2px',
//                       minWidth: '20px',
//                       height: '20px',
//                       color: '#666',
//                       '&:hover': {
//                         color: '#2e7d32',
//                       },
//                     }}
//                   >
//                     <OpenInNewIcon sx={{ fontSize: '14px' }} />
//                   </IconButton>
//                 </Tooltip>
//               </Box>
//             )}
//           </Box>
//         );

//       case 'chanel':
//         return <Typography variant="body2">{/* {lead.chanel?.name || 'N/A'} */}</Typography>;

//       case 'stage':
//         return <StageCell user={lead} mode={mode} isSmallScreen={isSmallScreen} />;

//       case 'Creation_date':
//         return (
//           // <Box>
//           //   <Typography variant="body2">
//           //     {lead.date ? moment(lead.date).format('DD/MM/YYYY') : 'N/A'}
//           //   </Typography>
//           //   <Typography variant="caption" color="text.secondary">
//           //     {lead.date ? moment(lead.date).format('h:mm A') : ''}
//           //   </Typography>
//           // </Box>
//           <Box>
//             {lead?.resetcreationdate === true ? (
//               <Typography variant="body2" color="text.secondary" fontStyle="italic">
//                 Not Available Now
//               </Typography>
//             ) : (
//               <>
//                 <Typography variant="body2">
//                   {lead.date ? moment(lead.date).format('DD/MM/YYYY') : 'N/A'}
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   {lead.date ? moment(lead.date).format('h:mm A') : ''}
//                 </Typography>
//               </>
//             )}
//           </Box>
//         );

//       case 'actions':
//         return (
//           <Box sx={{ display: 'flex', gap: 1 }}>
//             <Tooltip
//               title={
//                 lead.assign
//                   ? '⚠️ Lead assigned - Click to receive'
//                   : 'This lead is not assigned to you'
//               }
//             >
//               <Button
//                 onClick={lead.assign ? () => handleOpenReceiveModal(lead) : undefined}
//                 size="small"
//                 variant={lead.assign ? 'contained' : 'outlined'}
//                 color={lead.assign ? 'warning' : 'inherit'}
//                 disabled={!lead.assign}
//                 sx={{
//                   position: 'relative',
//                   overflow: 'hidden',
//                   transition: 'all 0.3s ease',
//                   minWidth: '100px',
//                   padding: lead.assign ? '6px 16px 6px 12px' : '6px 16px',
//                   animation: lead.assign ? 'pulse 1.5s infinite' : 'none',
//                   '&:hover': {
//                     transform: lead.assign ? 'translateY(-2px)' : 'none',
//                     boxShadow: lead.assign ? '0 4px 12px rgba(255, 152, 0, 0.3)' : 'none',
//                   },
//                   '&::before': lead.assign
//                     ? {
//                         content: '""',
//                         position: 'absolute',
//                         top: '-2px',
//                         left: '-2px',
//                         right: '-2px',
//                         bottom: '-2px',
//                         background: 'linear-gradient(45deg, #ff9800, #ff5722, #ff9800)',
//                         zIndex: -1,
//                         filter: 'blur(4px)',
//                         opacity: 0.6,
//                         animation: 'shimmer 2s infinite linear',
//                       }
//                     : {},
//                   '&.Mui-disabled': {
//                     backgroundColor:
//                       mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.06)',
//                     color: mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.26)',
//                     borderColor:
//                       mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)',
//                     cursor: 'not-allowed',
//                     opacity: 0.7,
//                     '&:hover': {
//                       backgroundColor:
//                         mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.06)',
//                       transform: 'none',
//                       boxShadow: 'none',
//                     },
//                   },
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'left',
//                     justifyContent: 'left',
//                     gap: '4px',
//                   }}
//                 >
//                   {lead.assign ? (
//                     <Box
//                       sx={{
//                         animation: 'bounce 0.8s infinite',
//                         marginRight: '2px',
//                       }}
//                     >
//                       <ArrowDownwardIcon
//                         sx={{
//                           fontSize: '18px',
//                           color: '#fff',
//                         }}
//                       />
//                     </Box>
//                   ) : null}

//                   <Typography
//                     variant="button"
//                     sx={{
//                       fontSize: '0.75rem',
//                       fontWeight: lead.assign ? '600' : '500',
//                       color: 'inherit',
//                     }}
//                   >
//                     {lead.assign ? 'Receive' : 'Recieved'}
//                   </Typography>

//                   {lead.assign && (
//                     <Box
//                       sx={{
//                         position: 'absolute',
//                         top: '-3px',
//                         right: '-3px',
//                         width: '8px',
//                         height: '8px',
//                         borderRadius: '50%',
//                         backgroundColor: '#ff0000',
//                         animation: 'pulseDot 1s infinite',
//                         border: '1px solid #fff',
//                       }}
//                     />
//                   )}

//                   {!lead.assign && (
//                     <Box
//                       sx={{
//                         position: 'absolute',
//                         top: '-3px',
//                         right: '-3px',
//                         width: '8px',
//                         height: '8px',
//                         borderRadius: '50%',
//                         backgroundColor: mode === 'dark' ? '#666' : '#999',
//                         border: '1px solid',
//                         borderColor: mode === 'dark' ? '#444' : '#ddd',
//                       }}
//                     />
//                   )}
//                 </Box>
//               </Button>
//             </Tooltip>

//             <Tooltip title="Edit Lead">
//               <Button
//                 size="small"
//                 variant="outlined"
//                 color="secondary"
//                 onClick={() => handleShowUpdateLead(lead)}
//               >
//                 Edit
//               </Button>
//             </Tooltip>
//           </Box>
//         );

//       default:
//         return <Typography variant="body2">{lead[col.key] || 'N/A'}</Typography>;
//     }
//   };

//   // Get visible columns
//   const getVisibleColumns = () => {
//     return tableConfig.columnOrder
//       .map((key) => tableConfig.columns.find((col) => col.key === key))
//       .filter((col) => col && col.visible);
//   };

//   // Styled Table Row
//   const StyledTableRow = styled(TableRow)(({ theme }) => ({
//     '&:nth-of-type(odd)': {
//       backgroundColor: mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
//     },
//     '&:hover': {
//       backgroundColor: mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.04)',
//     },
//   }));

//   // Loading State
//   if (!userlogin) {
//     return (
//       <Box
//         sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
//       >
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <LocalizationProvider dateAdapter={AdapterMoment}>
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: 'column',
//           minHeight: '100vh',
//           marginTop: isSmallScreen ? '120px' : isMediumScreen ? '80px' : '60px',
//           marginLeft: isSmallScreen ? '10px' : isMediumScreen ? '30px' : '50px',
//           marginRight: isSmallScreen ? '10px' : isMediumScreen ? '30px' : '50px',
//           padding: isSmallScreen ? '10px' : '20px',
//           backgroundColor: mode === 'dark' ? '#0a1929' : '#f8fafc',
//           position: 'relative',
//           overflow: 'hidden',
//         }}
//       >
//         {/* Header Section */}
//         <Box sx={{ marginTop: '30px', mb: 4 }}>
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               flexWrap: 'wrap',
//               gap: 2,
//               mb: 3,
//             }}
//           >
//             <Box>
//               <Typography
//                 variant="h4"
//                 fontWeight="bold"
//                 sx={{
//                   color: mode === 'dark' ? '#ffffff' : '#1976d2',
//                   mb: 1,
//                   fontSize: isSmallScreen ? '1.5rem' : '2rem',
//                 }}
//               >
//                 🎯 My Leads Center
//               </Typography>
//               <Typography
//                 variant="body1"
//                 sx={{
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)',
//                   fontSize: isSmallScreen ? '0.875rem' : '1rem',
//                 }}
//               >
//                 👋 Welcome, <strong>{userlogin.data?.name || 'Sales'}</strong> | 📊{' '}
//                 <strong>{pagination?.totalItems || displayLeads.length || 0}</strong> Total Leads
//               </Typography>
//             </Box>

//             <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//               <Link to="/addclient" style={{ textDecoration: 'none' }}>
//                 <Button
//                   variant="contained"
//                   startIcon={<AddCircleOutlineOutlinedIcon />}
//                   sx={{
//                     backgroundColor: '#1976d2',
//                     '&:hover': { backgroundColor: '#1565c0' },
//                     color: 'white',
//                     fontSize: isSmallScreen ? '0.75rem' : '0.875rem',
//                     py: 1,
//                   }}
//                 >
//                   + Add Lead
//                 </Button>
//               </Link>

//               <Button
//                 variant="outlined"
//                 startIcon={<FilterListIcon />}
//                 onClick={handleQuickFilterOpen}
//                 sx={{
//                   borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//                   color: mode === 'dark' ? '#fff' : '#1976d2',
//                   fontSize: isSmallScreen ? '0.75rem' : '0.875rem',
//                   py: 1,
//                 }}
//               >
//                 Quick Filter
//               </Button>


//  <Button
//           variant="outlined"
//           startIcon={<RequestPageOutlinedIcon />}
//           onClick={() => setRequestDialogOpen(true)}  // فتح الـ Dialog
//           sx={{
//             borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//             color: mode === 'dark' ? '#fff' : '#1976d2',
//             fontSize: isSmallScreen ? '0.75rem' : '0.875rem',
//             py: 1,
//           }}
//         >
//           Request Data
//         </Button>


//               <Button
//                 variant="outlined"
//                 startIcon={<RefreshIcon />}
//                 onClick={() => getallleadsforsales(currentPage, itemsPerPage, searchQuery)}
//                 disabled={loading}
//                 sx={{
//                   borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//                   color: mode === 'dark' ? '#fff' : '#1976d2',
//                   fontSize: isSmallScreen ? '0.75rem' : '0.875rem',
//                   py: 1,
//                 }}
//               >
//                 {loading ? 'Refreshing...' : 'Refresh'}
//               </Button>

//               <Button
//                 variant="outlined"
//                 startIcon={<SettingsIcon />}
//                 onClick={() => setTableSettingsOpen(true)}
//                 sx={{
//                   borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//                   color: mode === 'dark' ? '#fff' : '#1976d2',
//                   fontSize: isSmallScreen ? '0.75rem' : '0.875rem',
//                   py: 1,
//                 }}
//               >
//                 Table Settings
//               </Button>
//             </Box>
//           </Box>

//           {/* 🔥 أزرار الـ Sort السريع */}
//           <Box sx={{ display: 'flex', gap: 1, mt: 2, flexWrap: 'wrap' }}>
//             <Tooltip title="Show newest leads first">
//               <Button
//                 size="small"
//                 variant={
//                   sortConfig.key === 'Creation_date' && sortConfig.direction === 'descending'
//                     ? 'contained'
//                     : 'outlined'
//                 }
//                 onClick={() => handleQuickSort('newest')}
//                 startIcon={<ArrowDownwardIcon />}
//                 sx={{
//                   backgroundColor:
//                     sortConfig.key === 'Creation_date' && sortConfig.direction === 'descending'
//                       ? '#1976d2'
//                       : 'transparent',
//                 }}
//               >
//                 Newest First
//               </Button>
//             </Tooltip>

//             <Tooltip title="Show oldest leads first">
//               <Button
//                 size="small"
//                 variant={
//                   sortConfig.key === 'Creation_date' && sortConfig.direction === 'ascending'
//                     ? 'contained'
//                     : 'outlined'
//                 }
//                 onClick={() => handleQuickSort('oldest')}
//                 startIcon={<ArrowUpwardIcon />}
//                 sx={{
//                   backgroundColor:
//                     sortConfig.key === 'Creation_date' && sortConfig.direction === 'ascending'
//                       ? '#1976d2'
//                       : 'transparent',
//                 }}
//               >
//                 Oldest First
//               </Button>
//             </Tooltip>

//             <Tooltip title="Show recent stage updates first">
//               <Button
//                 size="small"
//                 variant={
//                   sortConfig.key === 'stage' && sortConfig.direction === 'descending'
//                     ? 'contained'
//                     : 'outlined'
//                 }
//                 onClick={() => handleQuickSort('recentStage')}
//                 startIcon={<AccessTimeIcon />}
//                 sx={{
//                   backgroundColor:
//                     sortConfig.key === 'stage' && sortConfig.direction === 'descending'
//                       ? '#1976d2'
//                       : 'transparent',
//                 }}
//               >
//                 Recent Stages
//               </Button>
//             </Tooltip>

//             {sortConfig.key && (
//               <Button
//                 size="small"
//                 variant="outlined"
//                 color="secondary"
//                 onClick={() => {
//                   setSortConfig({ key: null, direction: 'ascending' });
//                   Notify('info', 'Sorting cleared', 'info');
//                 }}
//                 startIcon={<ClearIcon />}
//               >
//                 Clear Sort
//               </Button>
//             )}
//           </Box>

//           {/* 🔥 بادج حالة الـ Sorting */}
//           {sortConfig.key && (
//             <Box sx={{ mt: 2 }}>
//               <Chip
//                 icon={
//                   sortConfig.direction === 'ascending' ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />
//                 }
//                 label={`Sorted by: ${sortConfig.key === 'Creation_date' ? 'Creation Date' : 'Stage Date'} (${sortConfig.direction === 'ascending' ? 'Oldest → Newest' : 'Newest → Oldest'})`}
//                 onDelete={() => {
//                   setSortConfig({ key: null, direction: 'ascending' });
//                   Notify('info', 'Sorting cleared', 'info');
//                 }}
//                 color="primary"
//                 variant="outlined"
//                 sx={{
//                   fontWeight: 'bold',
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(25, 118, 210, 0.2)' : 'rgba(25, 118, 210, 0.1)',
//                   borderColor: '#1976d2',
//                   animation: 'fadeIn 0.3s ease',
//                   '@keyframes fadeIn': {
//                     '0%': { opacity: 0, transform: 'translateY(-10px)' },
//                     '100%': { opacity: 1, transform: 'translateY(0)' },
//                   },
//                 }}
//               />
//             </Box>
//           )}
//         </Box>

//         {/* Table Section */}
//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 10 }}>
//             <CircularProgress size={60} />
//           </Box>
//         ) : (
//           <>
//             {/* Loading Progress Bar */}
//             {loading && (
//               <Box
//                 sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, zIndex: 9999 }}
//               >
//                 <LinearProgress />
//               </Box>
//             )}

//             <TableContainer
//               component={Paper}
//               sx={{
//                 borderRadius: 2,
//                 boxShadow:
//                   mode === 'dark' ? '0 8px 32px rgba(0,0,0,0.3)' : '0 8px 32px rgba(0,0,0,0.1)',
//                 mb: 3,
//                 maxHeight: 'calc(100vh - 400px)',
//                 overflow: 'auto',
//                 border:
//                   mode === 'dark' ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.1)',
//                 backgroundColor: mode === 'dark' ? '#0f172a' : '#ffffff',
//               }}
//             >
//               <Table
//                 stickyHeader
//                 sx={{ minWidth: 650 }}
//                 size={tableConfig.dense ? 'small' : 'medium'}
//               >
//                 <TableHead
//                   sx={{
//                     backgroundColor: mode === 'dark' ? '#1e293b' : '#1976d2',
//                     '& th': {
//                       borderBottom:
//                         mode === 'dark'
//                           ? '1px solid rgba(255,255,255,0.1)'
//                           : '1px solid rgba(255,255,255,0.2)',
//                     },
//                   }}
//                 >
//                   <TableRow>
//                     {getVisibleColumns().map((col) => (
//                       <TableCell
//                         key={col.key}
//                         sx={{
//                           color: tableConfig.whiteHeaders
//                             ? 'white'
//                             : mode === 'dark'
//                               ? 'white'
//                               : 'primary.contrastText',
//                           fontWeight: 'bold',
//                           width: `${col.width}px`,
//                           minWidth: `${col.width}px`,
//                           whiteSpace: 'nowrap',
//                           fontSize: '0.875rem',
//                           py: tableConfig.dense ? 1 : 2,
//                           px: 2,
//                           backgroundColor: mode === 'dark' ? '#1e293b' : '#1976d2',
//                           position: 'sticky',
//                           top: 0,
//                           zIndex: 10,
//                           cursor:
//                             col.key === 'Creation_date' || col.key === 'stage'
//                               ? 'pointer'
//                               : 'default',
//                           '&:hover':
//                             col.key === 'Creation_date' || col.key === 'stage'
//                               ? {
//                                   backgroundColor:
//                                     mode === 'dark'
//                                       ? 'rgba(255,255,255,0.15)'
//                                       : 'rgba(255,255,255,0.25)',
//                                 }
//                               : {},
//                           transition: 'background-color 0.2s ease',
//                         }}
//                         onClick={
//                           col.key === 'Creation_date' || col.key === 'stage'
//                             ? () => handleSort(col.key)
//                             : undefined
//                         }
//                       >
//                         <Box
//                           sx={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'space-between',
//                             gap: 1,
//                           }}
//                         >
//                           {col.key === 'selection' ? (
//                             <Box onClick={(e) => e.stopPropagation()}>
//                               <Checkbox
//                                 checked={
//                                   selectedLeads.length === displayLeads.length &&
//                                   displayLeads.length > 0
//                                 }
//                                 indeterminate={
//                                   selectedLeads.length > 0 &&
//                                   selectedLeads.length < displayLeads.length
//                                 }
//                                 onChange={handleSelectAll}
//                                 onClick={(e) => e.stopPropagation()}
//                                 sx={{
//                                   color: 'white',
//                                   '&.Mui-checked': { color: 'white' },
//                                   '&.MuiCheckbox-indeterminate': { color: 'white' },
//                                   '& .MuiSvgIcon-root': {
//                                     fontSize: tableConfig.dense ? 20 : 24,
//                                   },
//                                 }}
//                               />
//                             </Box>
//                           ) : (
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
//                               {col.label}

//                               {/* 🔥 أيقونات الـ sorting */}
//                               {(col.key === 'Creation_date' || col.key === 'stage') && (
//                                 <Box
//                                   sx={{
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     opacity: sortConfig.key === col.key ? 1 : 0.3,
//                                     transition: 'opacity 0.2s',
//                                     '&:hover': {
//                                       opacity: 0.8,
//                                     },
//                                   }}
//                                 >
//                                   <ArrowUpwardIcon
//                                     sx={{
//                                       fontSize: 12,
//                                       color:
//                                         sortConfig.key === col.key &&
//                                         sortConfig.direction === 'ascending'
//                                           ? '#ffeb3b'
//                                           : 'inherit',
//                                       mb: -0.5,
//                                     }}
//                                   />
//                                   <ArrowDownwardIcon
//                                     sx={{
//                                       fontSize: 12,
//                                       color:
//                                         sortConfig.key === col.key &&
//                                         sortConfig.direction === 'descending'
//                                           ? '#ffeb3b'
//                                           : 'inherit',
//                                       mt: -0.5,
//                                     }}
//                                   />
//                                 </Box>
//                               )}
//                             </Box>
//                           )}

//                           {/* 🔥 مؤشر الـ sorting النشط */}
//                           {sortConfig.key === col.key && (
//                             <Box
//                               sx={{
//                                 ml: 1,
//                                 animation: 'pulse 1.5s infinite',
//                                 '@keyframes pulse': {
//                                   '0%': { opacity: 0.6 },
//                                   '50%': { opacity: 1 },
//                                   '100%': { opacity: 0.6 },
//                                 },
//                               }}
//                             >
//                               {sortConfig.direction === 'ascending' ? (
//                                 <ArrowUpwardIcon sx={{ fontSize: 16, color: '#4caf50' }} />
//                               ) : (
//                                 <ArrowDownwardIcon sx={{ fontSize: 16, color: '#4caf50' }} />
//                               )}
//                             </Box>
//                           )}
//                         </Box>
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>

//                 <TableBody>
//                   {displayLeads.length > 0 ? (
//                     displayLeads.map((lead, index) => (
//                       <StyledTableRow
//                         key={lead._id || index}
//                         sx={{
//                           '&:hover': {
//                             transform: 'translateY(-1px)',
//                             transition: 'transform 0.2s ease-in-out',
//                             boxShadow:
//                               mode === 'dark'
//                                 ? '0 4px 12px rgba(0,0,0,0.3)'
//                                 : '0 4px 12px rgba(0,0,0,0.1)',
//                           },
//                         }}
//                       >
//                         {getVisibleColumns().map((col) => (
//                           <TableCell
//                             key={col.key}
//                             sx={{
//                               width: `${col.width}px`,
//                               minWidth: `${col.width}px`,
//                               verticalAlign: 'top',
//                               py: tableConfig.dense ? 1 : 2,
//                               px: 2,
//                               borderBottom:
//                                 mode === 'dark'
//                                   ? '1px solid rgba(255,255,255,0.05)'
//                                   : '1px solid rgba(0,0,0,0.05)',
//                               fontSize: tableConfig.dense ? '0.8125rem' : '0.875rem',
//                             }}
//                           >
//                             {renderCell(col, lead)}
//                           </TableCell>
//                         ))}
//                       </StyledTableRow>
//                     ))
//                   ) : (
//                     <TableRow>
//                       <TableCell colSpan={getVisibleColumns().length} align="center" sx={{ py: 8 }}>
//                         <Box sx={{ textAlign: 'center' }}>
//                           <Typography variant="h6" color="text.secondary" gutterBottom>
//                             {searchQuery || Object.keys(appliedFilters).length > 0
//                               ? '🔍 No results found for your search/filters'
//                               : '📭 No leads assigned to you yet'}
//                           </Typography>
//                           <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//                             {searchQuery || Object.keys(appliedFilters).length > 0
//                               ? 'Try adjusting your search terms or filters'
//                               : 'New leads will appear here when assigned'}
//                           </Typography>
//                           {(searchQuery || Object.keys(appliedFilters).length > 0) && (
//                             <Button
//                               variant="contained"
//                               onClick={handleClearAllFilters}
//                               sx={{ mt: 2 }}
//                             >
//                               Clear Search & Filters
//                             </Button>
//                           )}
//                         </Box>
//                       </TableCell>
//                     </TableRow>
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             {/* Fixed Pagination Container at Bottom */}
//             {displayLeads.length > 0 && pagination && (
//               <Paper
//                 elevation={3}
//                 sx={{
//                   position: 'sticky',
//                   bottom: 0,
//                   left: 0,
//                   right: 0,
//                   zIndex: 1000,
//                   p: 2,
//                   borderRadius: 2,
//                   backgroundColor: mode === 'dark' ? '#1e1e1e' : '#fff',
//                   border: mode === 'dark' ? '1px solid #333' : '1px solid #e0e0e0',
//                   mt: 2,
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     flexDirection: isSmallScreen ? 'column' : 'row',
//                     gap: 2,
//                     flexWrap: 'wrap',
//                   }}
//                 >
//                   {/* Left Section: Items Per Page و Page Info */}
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
//                     {/* Items Per Page Selector */}
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <Typography variant="body2" color="text.secondary">
//                         Items per page:
//                       </Typography>
//                       <TextField
//                         select
//                         value={itemsPerPage}
//                         onChange={handleItemsPerPageChange}
//                         size="small"
//                         sx={{ minWidth: 80 }}
//                       >
//                         <MenuItem value={5}>5</MenuItem>
//                         <MenuItem value={10}>10</MenuItem>
//                         <MenuItem value={25}>25</MenuItem>
//                         <MenuItem value={50}>50</MenuItem>
//                         <MenuItem value={100}>100</MenuItem>
//                       </TextField>
//                     </Box>

//                     {/* Page Navigation Info */}
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <Typography variant="body2" color="text.secondary">
//                         Page {currentPage} of {pagination.NumberOfPages || 1}
//                       </Typography>
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         onClick={handleOpenGoToPage}
//                         startIcon={<SearchIcon />}
//                         sx={{ ml: 1 }}
//                       >
//                         Go to Page
//                       </Button>
//                     </Box>
//                   </Box>

//                   {/* Middle Section: Pagination Controls */}
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     {/* Previous Button */}
//                     <Tooltip title="Previous Page">
//                       <span>
//                         <IconButton
//                           onClick={(e) => {
//                             if (pagination.prev) {
//                               handlePageChange(e, pagination.prev);
//                             }
//                           }}
//                           disabled={!pagination.prev}
//                           sx={{
//                             color: mode === 'dark' ? '#fff' : '#1976d2',
//                             '&:hover': {
//                               backgroundColor:
//                                 mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.1)',
//                             },
//                           }}
//                         >
//                           <ArrowBackIosNewIcon fontSize="small" />
//                         </IconButton>
//                       </span>
//                     </Tooltip>

//                     {/* Page Numbers - عرض 5 صفحات فقط */}
//                     {(() => {
//                       const totalPages = pagination.NumberOfPages || 1;
//                       const current = currentPage;
//                       const pages = [];

//                       let startPage = Math.max(1, current - 2);
//                       let endPage = Math.min(totalPages, current + 2);

//                       if (current <= 2) {
//                         endPage = Math.min(7, totalPages);
//                       }
//                       if (current >= totalPages - 1) {
//                         startPage = Math.max(1, totalPages - 4);
//                       }

//                       for (let i = startPage; i <= endPage; i++) {
//                         pages.push(
//                           <Button
//                             key={i}
//                             variant={current === i ? 'contained' : 'outlined'}
//                             onClick={(e) => handlePageChange(e, i)}
//                             sx={{
//                               minWidth: 32,
//                               height: 32,
//                               borderRadius: '4px',
//                               margin: '0 2px',
//                               backgroundColor:
//                                 current === i
//                                   ? mode === 'dark'
//                                     ? '#1976d2'
//                                     : '#1976d2'
//                                   : 'transparent',
//                               color: current === i ? '#fff' : mode === 'dark' ? '#fff' : '#1976d2',
//                               borderColor:
//                                 mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//                               '&:hover': {
//                                 backgroundColor:
//                                   current === i
//                                     ? mode === 'dark'
//                                       ? '#1565c0'
//                                       : '#1565c0'
//                                     : mode === 'dark'
//                                       ? 'rgba(255,255,255,0.1)'
//                                       : 'rgba(25,118,210,0.1)',
//                               },
//                             }}
//                           >
//                             {i}
//                           </Button>,
//                         );
//                       }

//                       return pages;
//                     })()}

//                     {/* Next Button */}
//                     <Tooltip title="Next Page">
//                       <span>
//                         <IconButton
//                           onClick={(e) => {
//                             if (pagination.next) {
//                               handlePageChange(e, pagination.next);
//                             }
//                           }}
//                           disabled={!pagination.next}
//                           sx={{
//                             color: mode === 'dark' ? '#fff' : '#1976d2',
//                             '&:hover': {
//                               backgroundColor:
//                                 mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(25,118,210,0.1)',
//                             },
//                           }}
//                         >
//                           <ArrowForwardIosIcon fontSize="small" />
//                         </IconButton>
//                       </span>
//                     </Tooltip>
//                   </Box>

//                   {/* Right Section: Results Info */}
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                     <Typography variant="body2" color="text.secondary">
//                       Showing{' '}
//                       <strong>
//                         {(() => {
//                           const totalItems = pagination?.totalItems || displayLeads.length;
//                           const start = (currentPage - 1) * itemsPerPage + 1;
//                           const end = Math.min(currentPage * itemsPerPage, totalItems);

//                           if (displayLeads.length < itemsPerPage) {
//                             return `${start}-${end}`;
//                           }

//                           if (currentPage === pagination.NumberOfPages) {
//                             return `${start}-${totalItems}`;
//                           }

//                           return `${start}-${end}`;
//                         })()}
//                       </strong>{' '}
//                       of <strong>{pagination?.totalItems || displayLeads.length}</strong> results
//                     </Typography>

//                     {(searchQuery || Object.keys(appliedFilters).length > 0) && (
//                       <Chip
//                         label="Filtered"
//                         size="small"
//                         color="primary"
//                         variant="outlined"
//                         sx={{ ml: 1 }}
//                       />
//                     )}

//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <Typography variant="caption" color="text.secondary">
//                         Show:
//                       </Typography>
//                       <Select
//                         value={itemsPerPage}
//                         onChange={handleItemsPerPageChange}
//                         size="small"
//                         sx={{
//                           width: 70,
//                           '& .MuiSelect-select': {
//                             py: 0.5,
//                           },
//                         }}
//                       >
//                         <MenuItem value={5}>5</MenuItem>
//                         <MenuItem value={10}>10</MenuItem>
//                         <MenuItem value={25}>25</MenuItem>
//                         <MenuItem value={50}>50</MenuItem>
//                         <MenuItem value={100}>100</MenuItem>
//                       </Select>
//                     </Box>
//                   </Box>
//                 </Box>

//                 {/* Progress Bar */}
//                 {pagination.NumberOfPages > 1 && (
//                   <Box sx={{ mt: 1 }}>
//                     <LinearProgress
//                       variant="determinate"
//                       value={(currentPage / pagination.NumberOfPages) * 100}
//                       sx={{
//                         height: 4,
//                         borderRadius: 2,
//                         backgroundColor:
//                           mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                         '& .MuiLinearProgress-bar': {
//                           backgroundColor: mode === 'dark' ? '#90caf9' : '#1976d2',
//                           borderRadius: 2,
//                         },
//                       }}
//                     />
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
//                       <Typography variant="caption" color="text.secondary">
//                         Page {currentPage}
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary">
//                         {pagination.NumberOfPages} pages total
//                       </Typography>
//                     </Box>
//                   </Box>
//                 )}
//               </Paper>
//             )}
//           </>
//         )}

//         {/* Quick Filter Modal */}
//         <SalesQuickFilterModal
//           open={quickFilterOpen}
//           onClose={handleQuickFilterClose}
//           onApplyFilters={handleApplyFilters}
//           initialFilters={appliedFilters}
//         />

//         {/* Table Settings Drawer */}
//         <Drawer
//           anchor="right"
//           open={tableSettingsOpen}
//           onClose={() => setTableSettingsOpen(false)}
//           PaperProps={{
//             sx: {
//               width: isSmallScreen ? '100%' : 400,
//               backgroundColor: mode === 'dark' ? '#1a1a1a' : '#ffffff',
//               backgroundImage: 'none',
//               marginTop: '25px',
//               boxShadow:
//                 mode === 'dark' ? '-8px 0 32px rgba(0,0,0,0.4)' : '-8px 0 32px rgba(0,0,0,0.1)',
//             },
//           }}
//         >
//           <Box sx={{ p: 3 }}>
//             <Typography
//               variant="h6"
//               gutterBottom
//               sx={{
//                 color: mode === 'dark' ? '#ffffff' : '#fff',
//                 fontWeight: 'bold',
//               }}
//             >
//               🛠️ Table Columns Settings
//             </Typography>

//             <Divider
//               sx={{
//                 my: 2,
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
//               }}
//             />

//             <Typography
//               variant="body2"
//               sx={{
//                 mb: 3,
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.7)',
//                 fontSize: '0.875rem',
//               }}
//             >
//               Drag to reorder, toggle visibility, and adjust column widths
//             </Typography>

//             <Divider
//               sx={{
//                 mb: 3,
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
//               }}
//             />

//             {/* Column Reordering Section */}
//             <Box sx={{ mb: 3 }}>
//               <Typography
//                 variant="subtitle1"
//                 gutterBottom
//                 sx={{
//                   color: mode === 'dark' ? '#ffffff' : '#fff',
//                   fontWeight: '600',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 1,
//                 }}
//               >
//                 📋 Column Order & Visibility
//               </Typography>

//               <DragDropContext onDragEnd={handleDragEnd}>
//                 <Droppable droppableId="columns">
//                   {(provided) => (
//                     <List
//                       {...provided.droppableProps}
//                       ref={provided.innerRef}
//                       sx={{
//                         backgroundColor:
//                           mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//                         borderRadius: 2,
//                         p: 1,
//                       }}
//                     >
//                       {tableConfig.columnOrder.map((columnKey, index) => {
//                         const column = tableConfig.columns.find((col) => col.key === columnKey);
//                         if (!column) return null;

//                         return (
//                           <Draggable key={column.key} draggableId={column.key} index={index}>
//                             {(provided, snapshot) => (
//                               <ListItem
//                                 ref={provided.innerRef}
//                                 {...provided.draggableProps}
//                                 {...provided.dragHandleProps}
//                                 sx={{
//                                   border: '1px solid',
//                                   borderColor:
//                                     mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                                   borderRadius: 2,
//                                   mb: 1,
//                                   backgroundColor: snapshot.isDragging
//                                     ? mode === 'dark'
//                                       ? 'rgba(144, 202, 249, 0.2)'
//                                       : 'rgba(25, 118, 210, 0.1)'
//                                     : mode === 'dark'
//                                       ? 'rgba(255,255,255,0.03)'
//                                       : 'rgba(255,255,255,0.8)',
//                                   transition: 'all 0.2s ease',
//                                   '&:hover': {
//                                     backgroundColor:
//                                       mode === 'dark'
//                                         ? 'rgba(255,255,255,0.08)'
//                                         : 'rgba(0,0,0,0.04)',
//                                     borderColor:
//                                       mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
//                                   },
//                                 }}
//                               >
//                                 <ListItemIcon sx={{ minWidth: 40 }}>
//                                   <Checkbox
//                                     checked={column.visible}
//                                     onChange={() => toggleColumnVisibility(column.key)}
//                                     icon={<VisibilityOffIcon />}
//                                     checkedIcon={<VisibilityIcon />}
//                                     sx={{
//                                       color:
//                                         mode === 'dark'
//                                           ? 'rgba(255,255,255,0.5)'
//                                           : 'rgba(0,0,0,0.5)',
//                                       '&.Mui-checked': {
//                                         color: '#4caf50',
//                                       },
//                                     }}
//                                   />
//                                 </ListItemIcon>

//                                 <ListItemText
//                                   primary={
//                                     <Typography
//                                       sx={{
//                                         color: column.visible
//                                           ? mode === 'dark'
//                                             ? '#ffffff'
//                                             : '#000000'
//                                           : mode === 'dark'
//                                             ? 'rgba(255,255,255,0.4)'
//                                             : 'rgba(0,0,0,0.4)',
//                                         fontWeight: '500',
//                                         fontSize: '0.9rem',
//                                         textDecoration: column.visible ? 'none' : 'line-through',
//                                       }}
//                                     >
//                                       {column.label}
//                                     </Typography>
//                                   }
//                                   secondary={
//                                     <Typography
//                                       sx={{
//                                         color:
//                                           mode === 'dark'
//                                             ? 'rgba(255,255,255,0.5)'
//                                             : 'rgba(0,0,0,0.5)',
//                                         fontSize: '0.75rem',
//                                       }}
//                                     >
//                                       Width: {column.width}px
//                                     </Typography>
//                                   }
//                                   sx={{ flex: 1 }}
//                                 />

//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                   <TextField
//                                     size="small"
//                                     type="number"
//                                     value={column.width}
//                                     onChange={(e) =>
//                                       updateColumnWidth(column.key, parseInt(e.target.value) || 100)
//                                     }
//                                     sx={{
//                                       width: 70,
//                                       '& .MuiInputBase-input': {
//                                         color: mode === 'dark' ? '#ffffff' : '#fff',
//                                         fontSize: '0.8rem',
//                                         padding: '6px 8px',
//                                         textAlign: 'center',
//                                       },
//                                       '& .MuiOutlinedInput-notchedOutline': {
//                                         borderColor:
//                                           mode === 'dark'
//                                             ? 'rgba(255,255,255,0.3)'
//                                             : 'rgba(0,0,0,0.3)',
//                                       },
//                                       '&:hover .MuiOutlinedInput-notchedOutline': {
//                                         borderColor: mode === 'dark' ? '#ffffff' : '#fff',
//                                       },
//                                     }}
//                                     inputProps={{
//                                       min: 60,
//                                       max: 400,
//                                       style: {
//                                         color: mode === 'dark' ? '#ffffff' : '#000000',
//                                       },
//                                     }}
//                                   />

//                                   <DragIndicatorIcon
//                                     sx={{
//                                       cursor: 'grab',
//                                       color:
//                                         mode === 'dark'
//                                           ? 'rgba(255,255,255,0.5)'
//                                           : 'rgba(0,0,0,0.5)',
//                                       '&:hover': {
//                                         color: mode === 'dark' ? '#ffffff' : '#000000',
//                                       },
//                                     }}
//                                   />
//                                 </Box>
//                               </ListItem>
//                             )}
//                           </Draggable>
//                         );
//                       })}
//                       {provided.placeholder}
//                     </List>
//                   )}
//                 </Droppable>
//               </DragDropContext>
//             </Box>

//             {/* Action Buttons */}
//             <Box sx={{ display: 'flex', gap: 1, flexDirection: isSmallScreen ? 'column' : 'row' }}>
//               <Button
//                 variant="outlined"
//                 fullWidth
//                 onClick={resetTableConfig}
//                 startIcon={<SettingsIcon />}
//                 sx={{
//                   color: mode === 'dark' ? '#ffffff' : '#000000',
//                   borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//                   '&:hover': {
//                     borderColor: mode === 'dark' ? '#ffffff' : '#fff',
//                     backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : '#fff',
//                   },
//                 }}
//               >
//                 Reset Defaults
//               </Button>

//               <Button
//                 variant="contained"
//                 fullWidth
//                 onClick={() => setTableSettingsOpen(false)}
//                 startIcon={<CheckIcon />}
//                 sx={{
//                   backgroundColor: '#1976d2',
//                   color: 'white',
//                   '&:hover': {
//                     backgroundColor: '#1565c0',
//                   },
//                 }}
//               >
//                 Apply Changes
//               </Button>
//             </Box>

//             {/* Quick Stats */}
//             <Box
//               sx={{
//                 mt: 3,
//                 p: 2,
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.05)',
//                 borderRadius: 2,
//                 border: '1px solid',
//                 borderColor:
//                   mode === 'dark' ? 'rgba(25, 118, 210, 0.3)' : 'rgba(25, 118, 210, 0.2)',
//               }}
//             >
//               <Typography
//                 variant="caption"
//                 sx={{
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#fff',
//                   fontWeight: '500',
//                 }}
//               >
//                 📊 Current Setup:
//               </Typography>
//               <Typography
//                 variant="caption"
//                 sx={{
//                   display: 'block',
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.6)' : '#fff',
//                 }}
//               >
//                 {tableConfig.columns.filter((col) => col.visible).length} of{' '}
//                 {tableConfig.columns.length} columns visible
//               </Typography>
//             </Box>
//           </Box>
//         </Drawer>

//         {/* Go to Page Dialog */}
//         <Dialog open={goToPageDialog} onClose={handleCloseGoToPage} maxWidth="xs" fullWidth>
//           <DialogTitle>Go to Page</DialogTitle>
//           <DialogContent>
//             <TextField
//               autoFocus
//               margin="dense"
//               label="Page Number"
//               type="number"
//               fullWidth
//               variant="outlined"
//               value={pageInput}
//               onChange={(e) => setPageInput(e.target.value)}
//               inputProps={{
//                 min: 1,
//                 max: pagination?.NumberOfPages || 1,
//               }}
//               helperText={`Enter a page number between 1 and ${pagination?.NumberOfPages || 1}`}
//               onKeyPress={(e) => {
//                 if (e.key === 'Enter') {
//                   handleGoToPage();
//                 }
//               }}
//             />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseGoToPage}>Cancel</Button>
//             <Button
//               onClick={handleGoToPage}
//               variant="contained"
//               disabled={
//                 !pageInput ||
//                 parseInt(pageInput) < 1 ||
//                 parseInt(pageInput) > (pagination?.NumberOfPages || 1)
//               }
//             >
//               Go
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Selection Snackbar */}
//         <Snackbar
//           open={selectedLeads.length > 0}
//           anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//           onClose={() => setSelectedLeads([])}
//           sx={{
//             '& .MuiSnackbarContent-root': {
//               backgroundColor: mode === 'dark' ? '#1e293b' : '#1976d2',
//               color: 'white',
//               borderRadius: 2,
//               boxShadow:
//                 mode === 'dark'
//                   ? '0 8px 32px rgba(0,0,0,0.4)'
//                   : '0 8px 32px rgba(25, 118, 210, 0.2)',
//             },
//           }}
//           message={
//             <Box sx={{ color: '#fff', display: 'flex', alignItems: 'center', gap: 1 }}>
//               <CheckIcon fontSize="small" />
//               <Typography variant="body2">
//                 <span style={{ color: '#fff' }}>{selectedLeads.length} lead(s) selected</span>
//               </Typography>
//             </Box>
//           }
//           action={
//             <React.Fragment>
//               <Tooltip title="Return to Team Leader">
//                 <IconButton
//                   size="small"
//                   onClick={handleReturnToTeamLeader}
//                   sx={{ color: '#fbbf24' }}
//                 >
//                   <ReplyIcon fontSize="small" />
//                 </IconButton>
//               </Tooltip>
//               <Button
//                 size="small"
//                 onClick={() => setSelectedLeads([])}
//                 sx={{
//                   color: 'white',
//                   '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' },
//                 }}
//               >
//                 Clear
//               </Button>
//             </React.Fragment>
//           }
//         />

//         {/* assign lead to teamleader dialog */}
//         <Dialog
//           open={confirmDialogOpen}
//           maxWidth="sm"
//           fullWidth
//           PaperProps={{
//             sx: {
//               borderRadius: 3,
//               backgroundColor: mode === 'dark' ? '#1a1a1a' : '#ffffff',
//               backgroundImage: 'none',
//               boxShadow:
//                 mode === 'dark' ? '0 20px 60px rgba(0,0,0,0.5)' : '0 20px 60px rgba(0,0,0,0.1)',
//               border: '1px solid',
//               borderColor: mode === 'dark' ? 'rgba(251, 191, 36, 0.3)' : 'rgba(251, 191, 36, 0.3)',
//             },
//           }}
//         >
//           <DialogTitle
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               borderBottom: '1px solid',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//               bgcolor: mode === 'dark' ? '#2d2d2d' : '#f8f9fa',
//               color: '#102dff',
//             }}
//           >
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//               <ReplyIcon />
//               <Typography variant="h6" fontWeight="bold">
//                 {confirmTitle}
//               </Typography>
//             </Box>
//             <IconButton
//               onClick={() => setConfirmDialogOpen(false)}
//               sx={{ color: mode === 'dark' ? '#fff' : '#000' }}
//             >
//               <ClearIcon />
//             </IconButton>
//           </DialogTitle>

//           <DialogContent sx={{ p: 3 }}>
//             <Box sx={{ textAlign: 'center', mb: 3 }}>
//               <Box
//                 sx={{
//                   width: 60,
//                   height: 60,
//                   borderRadius: '50%',
//                   bgcolor: 'rgba(251, 191, 36, 0.1)',
//                   display: 'inline-flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   border: '2px solid #fbbf24',
//                   mb: 2,
//                 }}
//               >
//                 <ReplyIcon sx={{ fontSize: 30, color: '#fbbf24' }} />
//               </Box>

//               <Typography
//                 variant="h6"
//                 gutterBottom
//                 sx={{
//                   color: mode === 'dark' ? '#fff' : '#333',
//                   fontWeight: '600',
//                 }}
//               >
//                 Confirm Your Action
//               </Typography>
//             </Box>

//             <Typography
//               variant="body1"
//               sx={{
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.9)',
//                 mb: 3,
//                 textAlign: 'center',
//                 lineHeight: 1.6,
//                 whiteSpace: 'pre-line',
//               }}
//             >
//               {confirmMessage}
//             </Typography>

//             <Alert
//               severity="info"
//               sx={{
//                 mb: 3,
//                 borderRadius: 2,
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(59, 130, 246, 0.1)' : 'rgba(59, 130, 246, 0.05)',
//                 '& .MuiAlert-icon': {
//                   color: mode === 'dark' ? '#60a5fa' : '#3b82f6',
//                 },
//               }}
//             >
//               <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                 <Typography variant="body2">
//                   <strong>Selected Leads:</strong> {selectedLeads.length}
//                 </Typography>
//               </Box>
//             </Alert>

//             <Alert
//               severity="warning"
//               sx={{
//                 borderRadius: 2,
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(251, 191, 36, 0.1)' : 'rgba(251, 191, 36, 0.05)',
//                 border: '1px solid',
//                 borderColor:
//                   mode === 'dark' ? 'rgba(251, 191, 36, 0.3)' : 'rgba(251, 191, 36, 0.3)',
//                 '& .MuiAlert-icon': {
//                   color: '#fbbf24',
//                 },
//               }}
//             >
//               <Typography variant="body2">
//                 <strong>⚠️ Important:</strong> Once returned, these leads will be transferred to
//                 your Team Leader and removed from your list.
//               </Typography>
//             </Alert>
//           </DialogContent>

//           <DialogActions
//             sx={{
//               p: 3,
//               borderTop: '1px solid',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//               bgcolor: mode === 'dark' ? '#2d2d2d' : '#f8f9fa',
//               gap: 2,
//             }}
//           >
//             <Button
//               onClick={() => {
//                 console.log('❌ Ignore clicked - closing dialog');
//                 setConfirmDialogOpen(false);
//                 Notify('info', 'Action cancelled', 'info');
//               }}
//               variant="outlined"
//               startIcon={<ClearIcon />}
//               sx={{
//                 flex: 1,
//                 color: mode === 'dark' ? '#fff' : '#666',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//                 '&:hover': {
//                   borderColor: mode === 'dark' ? '#fff' : '#000',
//                   backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.04)',
//                 },
//               }}
//             >
//               Ignore
//             </Button>

//             <Button
//               onClick={() => {
//                 console.log('✅ Confirm clicked - executing action');
//                 if (confirmAction) {
//                   confirmAction();
//                 }
//               }}
//               variant="contained"
//               startIcon={
//                 loadingreturnleadstoteamleader ? <CircularProgress size={16} /> : <CheckIcon />
//               }
//               sx={{
//                 flex: 1,
//                 backgroundColor: '#fbbf24',
//                 color: '#000',
//                 fontWeight: 'bold',
//                 '&:hover': {
//                   backgroundColor: '#f59e0b',
//                   transform: 'translateY(-1px)',
//                   boxShadow: '0 4px 12px rgba(251, 191, 36, 0.3)',
//                 },
//                 '&.Mui-disabled': {
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(251, 191, 36, 0.3)' : 'rgba(251, 191, 36, 0.5)',
//                   color: mode === 'dark' ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.7)',
//                 },
//                 transition: 'all 0.2s ease',
//               }}
//             >
//               {loadingreturnleadstoteamleader ? 'Processing...' : 'Confirm'}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* edit dialog -edit lead */}
//         <Dialog
//           open={showUpdateLead}
//           onClose={handleCloseUpdateLead}
//           maxWidth="sm"
//           fullWidth
//           PaperProps={{
//             sx: {
//               borderRadius: 3,
//               backgroundColor: mode === 'dark' ? '#1a1a1a' : '#ffffff',
//               backgroundImage: 'none',
//               boxShadow:
//                 mode === 'dark' ? '0 20px 60px rgba(0,0,0,0.5)' : '0 20px 60px rgba(0,0,0,0.1)',
//               border: '1px solid',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//             },
//           }}
//         >
//           <DialogTitle
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               borderBottom: '1px solid',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//               bgcolor: mode === 'dark' ? '#2d2d2d' : '#f8f9fa',
//               py: 2.5,
//               px: 3,
//             }}
//           >
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//               <EditNoteIcon sx={{ color: '#9c27b0', fontSize: 28 }} />
//               <Box>
//                 <Typography
//                   variant="h5"
//                   fontWeight="bold"
//                   sx={{
//                     color: mode === 'dark' ? '#fff' : '#333',
//                     lineHeight: 1.2,
//                   }}
//                 >
//                   Edit Lead
//                 </Typography>
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)',
//                     fontSize: '0.8rem',
//                   }}
//                 >
//                   Update lead information
//                 </Typography>
//               </Box>
//             </Box>
//             <IconButton
//               onClick={handleCloseUpdateLead}
//               sx={{
//                 color: mode === 'dark' ? '#fff' : '#666',
//                 '&:hover': {
//                   backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
//                   transform: 'rotate(90deg)',
//                   transition: 'transform 0.3s ease',
//                 },
//               }}
//             >
//               <ClearIcon />
//             </IconButton>
//           </DialogTitle>

//           <DialogContent sx={{ p: 3 }}>
//             {selectedLeadId && (
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 2,
//                   mb: 4,
//                   p: 2.5,
//                   borderRadius: 2,
//                   backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//                   border: '1px solid',
//                   borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                   boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
//                 }}
//               >
//                 <Avatar
//                   sx={{
//                     bgcolor: mode === 'dark' ? '#9c27b0' : '#9c27b0',
//                     width: 52,
//                     height: 52,
//                     fontSize: '18px',
//                     fontWeight: 'bold',
//                   }}
//                 >
//                   {leadnameupdate ? getInitials(leadnameupdate) : '??'}
//                 </Avatar>
//                 <Box sx={{ flex: 1 }}>
//                   <Typography
//                     variant="h6"
//                     fontWeight="600"
//                     sx={{
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       mb: 0.5,
//                     }}
//                   >
//                     {leadnameupdate || 'Unnamed Lead'}
//                   </Typography>
//                   <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
//                     <Chip
//                       label={`ID: ${selectedLeadId?.substring(0, 8)}...`}
//                       size="small"
//                       variant="outlined"
//                       sx={{
//                         fontSize: '0.75rem',
//                         height: 22,
//                         backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'transparent',
//                         borderColor: mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
//                       }}
//                     />
//                     {projectupdatelead?.name && (
//                       <Chip
//                         label={`Project: ${projectupdatelead.name}`}
//                         size="small"
//                         variant="outlined"
//                         sx={{
//                           fontSize: '0.75rem',
//                           height: 22,
//                           backgroundColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'transparent',
//                           borderColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
//                         }}
//                       />
//                     )}
//                   </Box>
//                 </Box>
//               </Box>
//             )}

//             <Box
//               component="form"
//               onSubmit={(e) => {
//                 e.preventDefault();
//                 handleUpdateLead();
//               }}
//             >
//               <Box sx={{ mb: 3.5 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
//                   <PersonIcon fontSize="small" sx={{ color: '#9c27b0' }} />
//                   <Typography
//                     variant="subtitle2"
//                     sx={{
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontWeight: '600',
//                       fontSize: '0.9rem',
//                     }}
//                   >
//                     Lead Name *
//                   </Typography>
//                 </Box>
//                 <TextField
//                   fullWidth
//                   value={leadnameupdate || ''}
//                   onChange={handleleadnameupdatechange}
//                   placeholder="Enter lead name"
//                   variant="outlined"
//                   size="small"
//                   required
//                   error={!leadnameupdate}
//                   helperText={!leadnameupdate ? 'Lead name is required' : ''}
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       borderRadius: 2,
//                       backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#fff',
//                       '&:hover .MuiOutlinedInput-notchedOutline': {
//                         borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//                       },
//                       '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                         borderColor: '#9c27b0',
//                         borderWidth: 2,
//                       },
//                     },
//                     '& .MuiFormHelperText-root': {
//                       marginLeft: 0,
//                       fontSize: '0.75rem',
//                     },
//                   }}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <PersonIcon
//                           fontSize="small"
//                           sx={{
//                             color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                           }}
//                         />
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </Box>

//               <Box sx={{ mb: 3.5 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
//                   <PhoneIcon fontSize="small" sx={{ color: '#2196f3' }} />
//                   <Typography
//                     variant="subtitle2"
//                     sx={{
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontWeight: '600',
//                       fontSize: '0.9rem',
//                     }}
//                   >
//                     Phone 2
//                   </Typography>
//                   <Typography variant="caption" sx={{ color: '#666', ml: 'auto' }}>
//                     Optional
//                   </Typography>
//                 </Box>

//                 <PhoneInput
//                   country={'ae'}
//                   value={phonenumber2 || ''}
//                   onChange={handlePhone2Change}
//                   onBlur={handleBlurphonenumber2}
//                   preferredCountries={['ae', 'sa', 'qa', 'bh', 'kw', 'om', 'us', 'gb']}
//                   enableSearch={true}
//                   searchPlaceholder="Search country..."
//                   searchNotFound="No country found"
//                   containerStyle={{
//                     width: '100%',
//                   }}
//                   inputStyle={{
//                     width: '100%',
//                     padding: '12px 14px',
//                     paddingLeft: '60px',
//                     fontSize: '15px',
//                     backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//                     color: mode === 'dark' ? '#fff' : '#333',
//                     border: '1px solid',
//                     borderColor: Errorphonenumber2
//                       ? '#f44336'
//                       : mode === 'dark'
//                         ? 'rgba(255,255,255,0.2)'
//                         : 'rgba(0,0,0,0.2)',
//                     borderRadius: '8px',
//                     fontFamily: 'inherit',
//                     '&:focus': {
//                       borderColor: '#2196f3',
//                       boxShadow: '0 0 0 2px rgba(33, 150, 243, 0.2)',
//                       outline: 'none',
//                     },
//                   }}
//                   buttonStyle={{
//                     backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//                     border: '1px solid',
//                     borderColor: Errorphonenumber2
//                       ? '#f44336'
//                       : mode === 'dark'
//                         ? 'rgba(255,255,255,0.2)'
//                         : 'rgba(0,0,0,0.2)',
//                     borderRight: 'none',
//                     borderRadius: '8px 0 0 8px',
//                     padding: '0 10px',
//                     width: '55px',
//                     '&:hover': {
//                       backgroundColor: mode === 'dark' ? '#3d3d3d' : '#f5f5f5',
//                     },
//                   }}
//                   dropdownStyle={{
//                     backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//                     color: mode === 'dark' ? '#fff' : '#333',
//                     borderRadius: '8px',
//                     boxShadow:
//                       mode === 'dark'
//                         ? '0 10px 40px rgba(0,0,0,0.3)'
//                         : '0 10px 40px rgba(0,0,0,0.1)',
//                     border: '1px solid',
//                     borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                     maxHeight: '300px',
//                     overflowY: 'auto',
//                     zIndex: 9999,
//                   }}
//                 />

//                 {Errorphonenumber2 && (
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       color: '#f44336',
//                       fontSize: '0.75rem',
//                       mt: 1,
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 0.5,
//                       fontWeight: '500',
//                     }}
//                   >
//                     <ErrorIcon fontSize="small" /> {Errorphonenumber2}
//                   </Typography>
//                 )}
//               </Box>

//               <Box sx={{ mb: 3.5 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
//                   <WhatsAppIcon fontSize="small" sx={{ color: '#25D366' }} />
//                   <Typography
//                     variant="subtitle2"
//                     sx={{
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontWeight: '600',
//                       fontSize: '0.9rem',
//                     }}
//                   >
//                     WhatsApp Number
//                   </Typography>
//                   <Typography variant="caption" sx={{ color: '#666', ml: 'auto' }}>
//                     Optional
//                   </Typography>
//                 </Box>

//                 <PhoneInput
//                   country={'ae'}
//                   value={whatsappnumber || ''}
//                   onChange={handlewhatsappnumberChange}
//                   onBlur={handleBlurwhatsappnumber}
//                   preferredCountries={['ae', 'sa', 'qa', 'bh', 'kw', 'om']}
//                   enableSearch={true}
//                   searchPlaceholder="Search country..."
//                   containerStyle={{
//                     width: '100%',
//                   }}
//                   inputStyle={{
//                     width: '100%',
//                     padding: '12px 14px',
//                     paddingLeft: '60px',
//                     fontSize: '15px',
//                     backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//                     color: mode === 'dark' ? '#fff' : '#333',
//                     border: '1px solid',
//                     borderColor: whatsappnumbererror
//                       ? '#f44336'
//                       : mode === 'dark'
//                         ? 'rgba(255,255,255,0.2)'
//                         : 'rgba(0,0,0,0.2)',
//                     borderRadius: '8px',
//                     fontFamily: 'inherit',
//                     '&:focus': {
//                       borderColor: '#25D366',
//                       boxShadow: '0 0 0 2px rgba(37, 211, 102, 0.2)',
//                       outline: 'none',
//                     },
//                   }}
//                   buttonStyle={{
//                     backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//                     border: '1px solid',
//                     borderColor: whatsappnumbererror
//                       ? '#f44336'
//                       : mode === 'dark'
//                         ? 'rgba(255,255,255,0.2)'
//                         : 'rgba(0,0,0,0.2)',
//                     borderRight: 'none',
//                     borderRadius: '8px 0 0 8px',
//                     padding: '0 10px',
//                     width: '55px',
//                     '&:hover': {
//                       backgroundColor: mode === 'dark' ? '#3d3d3d' : '#f5f5f5',
//                     },
//                   }}
//                 />

//                 {whatsappnumbererror && (
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       color: '#f44336',
//                       fontSize: '0.75rem',
//                       mt: 1,
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 0.5,
//                       fontWeight: '500',
//                     }}
//                   >
//                     <ErrorIcon fontSize="small" /> {whatsappnumbererror}
//                   </Typography>
//                 )}

//                 <Typography
//                   variant="caption"
//                   sx={{
//                     color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                     fontSize: '0.75rem',
//                     mt: 1,
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 0.5,
//                   }}
//                 >
//                   <InfoIcon fontSize="small" /> Use WhatsApp-enabled phone number for direct
//                   messaging
//                 </Typography>
//               </Box>

//               <Box sx={{ mb: 3 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
//                   <BusinessCenterIcon fontSize="small" sx={{ color: '#ff9800' }} />
//                   <Typography
//                     variant="subtitle2"
//                     sx={{
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontWeight: '600',
//                       fontSize: '0.9rem',
//                     }}
//                   >
//                     Project *
//                   </Typography>
//                 </Box>

//                 {resproject?.data && Array.isArray(resproject.data) ? (
//                   <Autocomplete
//                     fullWidth
//                     options={resproject.data}
//                     getOptionLabel={(option) => option.name || ''}
//                     value={projectupdatelead || null}
//                     onChange={(event, newValue) => onprojectupdateleadchange(newValue)}
//                     isOptionEqualToValue={(option, value) => option._id === value?._id}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         placeholder="Search or select a project"
//                         variant="outlined"
//                         size="small"
//                         required
//                         error={!projectupdatelead}
//                         helperText={!projectupdatelead ? 'Please select a project' : ''}
//                         sx={{
//                           '& .MuiOutlinedInput-root': {
//                             borderRadius: 2,
//                             backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#fff',
//                             '&:hover .MuiOutlinedInput-notchedOutline': {
//                               borderColor:
//                                 mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//                             },
//                             '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                               borderColor: '#ff9800',
//                               borderWidth: 2,
//                             },
//                           },
//                           '& .MuiFormHelperText-root': {
//                             marginLeft: 0,
//                             fontSize: '0.75rem',
//                           },
//                         }}
//                         InputProps={{
//                           ...params.InputProps,
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <SearchIcon
//                                 fontSize="small"
//                                 sx={{
//                                   color:
//                                     mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                                 }}
//                               />
//                             </InputAdornment>
//                           ),
//                         }}
//                       />
//                     )}
//                     renderOption={(props, option) => (
//                       <li {...props} style={{ padding: '12px 16px' }}>
//                         <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
//                           <Typography variant="body2" fontWeight="medium">
//                             {option.name}
//                           </Typography>
//                           {option.developer?.name && (
//                             <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
//                               🏢 {option.developer.name}
//                             </Typography>
//                           )}
//                           {option.location && (
//                             <Typography variant="caption" color="text.secondary">
//                               📍 {option.location}
//                             </Typography>
//                           )}
//                         </Box>
//                       </li>
//                     )}
//                     noOptionsText={
//                       <Box sx={{ p: 2, textAlign: 'center' }}>
//                         <Typography variant="body2">No projects found</Typography>
//                         <Typography variant="caption" color="text.secondary">
//                           Try a different search term
//                         </Typography>
//                       </Box>
//                     }
//                     sx={{
//                       '& .MuiAutocomplete-listbox': {
//                         maxHeight: 300,
//                         backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//                         border: '1px solid',
//                         borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                         borderRadius: '0 0 8px 8px',
//                       },
//                       '& .MuiAutocomplete-option': {
//                         borderBottom: '1px solid',
//                         borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                         '&:last-child': {
//                           borderBottom: 'none',
//                         },
//                         '&:hover': {
//                           backgroundColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
//                         },
//                       },
//                     }}
//                   />
//                 ) : (
//                   <Alert
//                     severity="info"
//                     sx={{
//                       borderRadius: 2,
//                       backgroundColor:
//                         mode === 'dark' ? 'rgba(33, 150, 243, 0.1)' : 'rgba(33, 150, 243, 0.05)',
//                       border: '1px solid',
//                       borderColor:
//                         mode === 'dark' ? 'rgba(33, 150, 243, 0.2)' : 'rgba(33, 150, 243, 0.2)',
//                     }}
//                   >
//                     <Typography variant="body2">Loading projects...</Typography>
//                   </Alert>
//                 )}
//               </Box>
//             </Box>
//           </DialogContent>

//           <DialogActions
//             sx={{
//               p: 3,
//               borderTop: '1px solid',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//               bgcolor: mode === 'dark' ? '#2d2d2d' : '#f8f9fa',
//               gap: 2,
//             }}
//           >
//             <Button
//               onClick={handleCloseUpdateLead}
//               variant="outlined"
//               startIcon={<ClearIcon />}
//               sx={{
//                 color: mode === 'dark' ? '#fff' : '#666',
//                 borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//                 '&:hover': {
//                   borderColor: mode === 'dark' ? '#fff' : '#000',
//                   backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.04)',
//                   transform: 'translateY(-1px)',
//                   boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                 },
//                 transition: 'all 0.2s ease',
//                 borderRadius: 2,
//                 px: 3,
//                 py: 0.75,
//               }}
//             >
//               Cancel
//             </Button>

//             <Button
//               onClick={handleUpdateLead}
//               variant="contained"
//               startIcon={
//                 loadingupdatelead2 ? <CircularProgress size={16} color="inherit" /> : <SaveIcon />
//               }
//               disabled={loadingupdatelead2 || !leadnameupdate || !projectupdatelead}
//               sx={{
//                 backgroundColor: '#9c27b0',
//                 color: 'white',
//                 fontWeight: 'bold',
//                 '&:hover': {
//                   backgroundColor: '#7b1fa2',
//                   transform: 'translateY(-1px)',
//                   boxShadow: '0 4px 12px rgba(156, 39, 176, 0.3)',
//                 },
//                 transition: 'all 0.2s ease',
//                 borderRadius: 2,
//                 px: 3,
//                 py: 0.75,
//                 '&.Mui-disabled': {
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(156, 39, 176, 0.3)' : 'rgba(156, 39, 176, 0.5)',
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.7)',
//                 },
//               }}
//             >
//               {loadingupdatelead2 ? 'Updating...' : 'Update Lead'}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* sales Recieve New Lead Dialog */}
//         <Dialog
//           style={{ zIndex: '60000' }}
//           open={showReceiveModal}
//           onClose={() => {
//             setShowReceiveModal(false);
//             setSelectedLeadForReceive(null);
//           }}
//           maxWidth="sm"
//           fullWidth
//           PaperProps={{
//             sx: {
//               borderRadius: 3,
//               backgroundColor:
//                 mode === 'dark'
//                   ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                   : 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
//               backgroundImage: 'none',
//               boxShadow:
//                 mode === 'dark'
//                   ? '0 20px 60px rgba(0,0,0,0.5)'
//                   : '0 20px 60px rgba(16, 45, 255, 0.15)',
//               border: '1px solid',
//               borderColor: mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(16, 45, 255, 0.1)',
//               overflow: 'hidden',
//               position: 'relative',
//             },
//           }}
//         >
//           <div
//             style={{
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               right: 0,
//               height: '4px',
//               background: 'linear-gradient(90deg, #102dff, #4a6fff, #102dff)',
//               backgroundSize: '200% 100%',
//               animation: 'shimmer 2s infinite linear',
//             }}
//           />

//           <IconButton
//             onClick={() => {
//               setShowReceiveModal(false);
//               setSelectedLeadForReceive(null);
//             }}
//             sx={{
//               position: 'absolute',
//               top: '16px',
//               right: '16px',
//               width: '36px',
//               height: '36px',
//               borderRadius: '50%',
//               background: mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(16, 45, 255, 0.1)',
//               color: mode === 'dark' ? '#fff' : '#102dff',
//               zIndex: 10,
//               transition: 'all 0.3s ease',
//               '&:hover': {
//                 background: mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(16, 45, 255, 0.2)',
//                 transform: 'rotate(90deg)',
//               },
//             }}
//           >
//             <ClearIcon fontSize="small" />
//           </IconButton>

//           <Box sx={{ padding: '32px' }}>
//             <Box
//               sx={{
//                 textAlign: 'center',
//                 marginBottom: '28px',
//                 position: 'relative',
//               }}
//             >
//               <Box
//                 sx={{
//                   width: '70px',
//                   height: '70px',
//                   background: 'linear-gradient(135deg, #102dff 0%, #4a6fff 100%)',
//                   borderRadius: '50%',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   margin: '0 auto 20px',
//                   boxShadow: '0 8px 24px rgba(16, 45, 255, 0.3)',
//                   animation: 'pulse 2s infinite',
//                 }}
//               >
//                 <PersonAddIcon sx={{ color: '#fff', fontSize: 32 }} />
//               </Box>

//               <Typography
//                 variant="h4"
//                 fontWeight="700"
//                 sx={{
//                   color: mode === 'dark' ? '#fff' : '#333',
//                   marginBottom: '8px',
//                   background: 'linear-gradient(90deg, #102dff, #4a6fff)',
//                   WebkitBackgroundClip: 'text',
//                   WebkitTextFillColor: 'transparent',
//                   backgroundClip: 'text',
//                   fontSize: '2rem',
//                 }}
//               >
//                 Receive Lead
//               </Typography>

//               <Typography
//                 variant="body1"
//                 sx={{
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)',
//                   fontSize: '0.95rem',
//                   maxWidth: '400px',
//                   margin: '0 auto',
//                   lineHeight: 1.5,
//                 }}
//               >
//                 You're about to take ownership of this lead
//               </Typography>
//             </Box>

//             {selectedLeadForReceive && (
//               <>
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     background:
//                       mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(16, 45, 255, 0.05)',
//                     padding: '24px',
//                     borderRadius: '16px',
//                     marginBottom: '28px',
//                     border: `1px solid ${mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(16, 45, 255, 0.1)'}`,
//                     backdropFilter: 'blur(10px)',
//                   }}
//                 >
//                   <Typography
//                     variant="body1"
//                     sx={{
//                       color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.9)',
//                       fontSize: '1.05rem',
//                       lineHeight: 1.6,
//                       textAlign: 'center',
//                       marginBottom: '16px',
//                     }}
//                   >
//                     Hi{' '}
//                     <span
//                       style={{
//                         color: '#102dff',
//                         fontWeight: '600',
//                         background:
//                           mode === 'dark' ? 'rgba(16, 45, 255, 0.2)' : 'rgba(16, 45, 255, 0.1)',
//                         padding: '4px 12px',
//                         borderRadius: '20px',
//                         display: 'inline-block',
//                       }}
//                     >
//                       {userlogin?.data?.name || userlogin?.name}
//                     </span>
//                     ,
//                   </Typography>

//                   <Typography
//                     variant="body1"
//                     sx={{
//                       color: mode === 'dark' ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.8)',
//                       fontSize: '1.05rem',
//                       lineHeight: 1.6,
//                       textAlign: 'center',
//                       marginBottom: '20px',
//                     }}
//                   >
//                     Please receive the lead and contact with
//                     <span
//                       style={{
//                         color: '#102dff',
//                         fontWeight: '600',
//                         margin: '0 4px',
//                       }}
//                     >
//                       {selectedLeadForReceive.name}
//                     </span>
//                     ...
//                   </Typography>

//                   <Typography
//                     variant="body1"
//                     sx={{
//                       color: mode === 'dark' ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.8)',
//                       fontSize: '1.05rem',
//                       lineHeight: 1.6,
//                       textAlign: 'center',
//                       fontWeight: '600',
//                     }}
//                   >
//                     Thank You.
//                   </Typography>
//                 </Paper>

//                 <Paper
//                   elevation={0}
//                   sx={{
//                     background:
//                       mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.8)',
//                     padding: '20px',
//                     borderRadius: '16px',
//                     marginBottom: '32px',
//                     border: `1px solid ${mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0,0,0,0.1)'}`,
//                   }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, marginBottom: '20px' }}>
//                     <Avatar
//                       sx={{
//                         width: 50,
//                         height: 50,
//                         background: 'linear-gradient(135deg, #102dff 0%, #4a6fff 100%)',
//                         fontSize: '18px',
//                         fontWeight: 'bold',
//                       }}
//                     >
//                       {getInitials(selectedLeadForReceive.name)}
//                     </Avatar>
//                     <Box>
//                       <Typography
//                         variant="h6"
//                         fontWeight="600"
//                         sx={{
//                           color: mode === 'dark' ? '#fff' : '#333',
//                         }}
//                       >
//                         {selectedLeadForReceive.name}
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         sx={{
//                           color: mode === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
//                         }}
//                       >
//                         Lead Details
//                       </Typography>
//                     </Box>
//                   </Box>

//                   <Grid container spacing={2}>
//                     {selectedLeadForReceive.phone && (
//                       <Grid item xs={6}>
//                         <Box
//                           sx={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: 1,
//                             padding: '10px',
//                             background:
//                               mode === 'dark'
//                                 ? 'rgba(255, 255, 255, 0.03)'
//                                 : 'rgba(16, 45, 255, 0.03)',
//                             borderRadius: '8px',
//                           }}
//                         >
//                           <PhoneIcon sx={{ color: '#102dff', fontSize: 18 }} />
//                           <Typography
//                             variant="body2"
//                             sx={{
//                               color: mode === 'dark' ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.8)',
//                             }}
//                           >
//                             {selectedLeadForReceive.phone}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     )}

//                     {selectedLeadForReceive.email && (
//                       <Grid item xs={6}>
//                         <Box
//                           sx={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: 1,
//                             padding: '10px',
//                             background:
//                               mode === 'dark'
//                                 ? 'rgba(255, 255, 255, 0.03)'
//                                 : 'rgba(16, 45, 255, 0.03)',
//                             borderRadius: '8px',
//                           }}
//                         >
//                           <EmailIcon sx={{ color: '#102dff', fontSize: 18 }} />
//                           <Typography
//                             variant="body2"
//                             sx={{
//                               color: mode === 'dark' ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.8)',
//                             }}
//                           >
//                             {selectedLeadForReceive.email}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     )}

//                     {selectedLeadForReceive.project?.name && (
//                       <Grid item xs={12}>
//                         <Box
//                           sx={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: 1,
//                             padding: '10px',
//                             background:
//                               mode === 'dark'
//                                 ? 'rgba(255, 255, 255, 0.03)'
//                                 : 'rgba(16, 45, 255, 0.03)',
//                             borderRadius: '8px',
//                           }}
//                         >
//                           <BusinessCenterIcon sx={{ color: '#102dff', fontSize: 18 }} />
//                           <Typography
//                             variant="body2"
//                             sx={{
//                               color: mode === 'dark' ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.8)',
//                             }}
//                           >
//                             Project: {selectedLeadForReceive.project.name}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     )}
//                   </Grid>
//                 </Paper>

//                 <Box sx={{ textAlign: 'center' }}>
//                   <Button
//                     fullWidth
//                     variant="contained"
//                     onClick={handleReceiveLead}
//                     disabled={receiveLoading}
//                     startIcon={
//                       receiveLoading ? (
//                         <CircularProgress size={20} sx={{ color: '#fff' }} />
//                       ) : (
//                         <ArrowForwardIcon />
//                       )
//                     }
//                     sx={{
//                       background: 'linear-gradient(135deg, #102dff 0%, #4a6fff 100%)',
//                       color: '#fff',
//                       padding: '16px 32px',
//                       borderRadius: '12px',
//                       fontSize: '1.1rem',
//                       fontWeight: '600',
//                       textTransform: 'none',
//                       boxShadow: '0 8px 24px rgba(16, 45, 255, 0.3)',
//                       transition: 'all 0.3s ease',
//                       '&:hover': {
//                         transform: 'translateY(-2px)',
//                         boxShadow: '0 12px 32px rgba(16, 45, 255, 0.4)',
//                         background: 'linear-gradient(135deg, #0d1fd1 0%, #3a5eff 100%)',
//                       },
//                       '&:disabled': {
//                         background:
//                           mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
//                         color: mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)',
//                       },
//                       minHeight: '56px',
//                       position: 'relative',
//                       overflow: 'hidden',
//                     }}
//                   >
//                     {receiveLoading ? 'Processing...' : 'Okay, I Want To Receive'}
//                     <Box
//                       sx={{
//                         position: 'absolute',
//                         top: 0,
//                         left: 0,
//                         right: 0,
//                         bottom: 0,
//                         background:
//                           'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
//                         transform: 'translateX(-100%)',
//                         transition: 'transform 0.6s',
//                       }}
//                       className="shimmer-effect"
//                     />
//                   </Button>

//                   <Typography
//                     variant="caption"
//                     sx={{
//                       color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                       display: 'block',
//                       marginTop: '12px',
//                       fontSize: '0.85rem',
//                     }}
//                   >
//                     By clicking receive, you'll take full responsibility for this lead
//                   </Typography>
//                 </Box>
//               </>
//             )}
//           </Box>

//           <Box
//             sx={{
//               padding: '16px 32px',
//               background: mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(16, 45, 255, 0.03)',
//               borderTop: `1px solid ${mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(16, 45, 255, 0.1)'}`,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               gap: '8px',
//             }}
//           >
//             <CheckCircleIcon
//               sx={{
//                 color: '#06D6A0',
//                 fontSize: 18,
//               }}
//             />
//             <Typography
//               variant="caption"
//               sx={{
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
//                 fontSize: '0.85rem',
//                 fontWeight: '500',
//               }}
//             >
//               Secure and confidential lead transfer
//             </Typography>
//           </Box>

//           <style>
//             {`
//               @keyframes shimmer {
//                 0% {
//                   background-position: -200% 0;
//                 }
//                 100% {
//                   background-position: 200% 0;
//                 }
//               }
              
//               @keyframes pulse {
//                 0% {
//                   transform: scale(1);
//                   boxShadow: 0 8px 24px rgba(16, 45, 255, 0.3);
//                 }
//                 50% {
//                   transform: scale(1.05);
//                   boxShadow: 0 12px 32px rgba(16, 45, 255, 0.4);
//                 }
//                 100% {
//                   transform: scale(1);
//                   boxShadow: 0 8px 24px rgba(16, 45, 255, 0.3);
//                 }
//               }
              
//               .shimmer-effect {
//                 animation: shimmer 2s infinite;
//               }
              
//               button:hover .shimmer-effect {
//                 transform: translateX(100%);
//               }
//             `}
//           </style>
//         </Dialog>

//         {/* 🔥 مكون ShowClientsActions */}
//         {/* {selectedLead && (
//           <ShowClientsActions 
//             user={selectedLead} 
//             leadid={selectedLead._id}
//             onClose={() => {
//               console.log('Closing client actions');
//               setSelectedLead(null);
//             }}
//             open={!!selectedLead}
//             refreshData={() => getallleadsforsales(currentPage, itemsPerPage, searchQuery)}
//           />
//         )} */}


// <SalesRequestData_Model
//         open={requestDialogOpen}
//         onClose={() => setRequestDialogOpen(false)}
//         // onSubmit={handleRequestSubmit}
//       />


//         {selectedLead && (
//           <ShowClientsActionsAdvanced
//             user={selectedLead}
//             leadid={selectedLead._id}
//             onClose={() => setSelectedLead(null)}
//           />
//         )}
//       </Box>
//     </LocalizationProvider>
//   );
// };



























// 20-5-2026
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, CircularProgress, Pagination,
  Avatar, TextField, MenuItem, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, IconButton, Checkbox, Tooltip,
  Snackbar, Drawer, Alert, Autocomplete,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTheme, useMediaQuery } from '@mui/material';

import CheckIcon                      from '@mui/icons-material/Check';
import EditNoteIcon                   from '@mui/icons-material/EditNote';
import AssignmentTurnedInIcon         from '@mui/icons-material/AssignmentTurnedIn';
import TransferWithinAStationIcon     from '@mui/icons-material/TransferWithinAStation';
import SevereColdIcon                 from '@mui/icons-material/SevereCold';
import FilterListIcon                 from '@mui/icons-material/FilterList';
import RefreshIcon                    from '@mui/icons-material/Refresh';
import SettingsIcon                   from '@mui/icons-material/Settings';
import AddIcon                        from '@mui/icons-material/Add';
import CloseIcon                      from '@mui/icons-material/Close';
import VisibilityIcon                 from '@mui/icons-material/Visibility';
import VisibilityOffIcon              from '@mui/icons-material/VisibilityOff';
import ReplyIcon                      from '@mui/icons-material/Reply';
import ArrowDownwardIcon              from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon                from '@mui/icons-material/ArrowUpward';
import AccessTimeIcon                 from '@mui/icons-material/AccessTime';
import ClearIcon                      from '@mui/icons-material/Clear';
import PhoneIcon                      from '@mui/icons-material/Phone';
import WhatsAppIcon                   from '@mui/icons-material/WhatsApp';
import ContentCopyIcon                from '@mui/icons-material/ContentCopy';
import CheckCircleIcon                from '@mui/icons-material/CheckCircle';
import OpenInNewIcon                  from '@mui/icons-material/OpenInNew';
import RequestPageOutlinedIcon        from '@mui/icons-material/RequestPageOutlined';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import moment from 'moment';

import { GetallLeads_data_With_Email2 }                                          from '../../Redux/Actions/RoleData_Actions';
import { UpdateClientAction, UpdateClientActionToReaciveusertolead }             from '../../Redux/Actions/UsersAction';
import { GetallProjectsdata }                                                    from '../../Redux/Actions/Projects_Action';
import { Get_sales_Login_For_Assign_Leads_To_histeamleader_Action }             from '../../Redux/Actions/SalesAction';
import { Notify }                                                                from '../../Utility/Notify';
import { ShowClientsActionsAdvanced }                                            from '../../Pages/ShowClientsActionsAdvanced';
import SalesQuickFilterModal                                                     from '../../Pages/SalesQuickFilterModal';
import { SalesRequestData_Model }                                                from './SalesRequestData_Model';
import { useSidebarWidth }                                                       from '../../Utility/useSidebarWidth';

// ─── Design Tokens ────────────────────────────────────────────────────────────
const C = {
  bg:          '#F7F8FC',
  white:       '#FFFFFF',
  border:      '#E8EAF0',
  accent:      '#0D47A1',
  accentDark:  '#1330A6',
  accentSoft:  'rgba(26,62,207,0.07)',
  text:        '#1C2340',
  textMuted:   '#7B829A',
  success:     '#12B76A',
  successSoft: 'rgba(18,183,106,0.08)',
  warning:     '#F79009',
  danger:      '#F04438',
  dangerSoft:  'rgba(240,68,56,0.08)',
  shadow:      '0 1px 3px rgba(16,24,40,0.08)',
};

const SIDEBAR_COLLAPSED = 64;

// ─── Styled Row ───────────────────────────────────────────────────────────────
const StyledRow = styled(TableRow)(() => ({
  '&:hover': { backgroundColor: 'rgba(26,62,207,0.03)' },
  '& td':    { borderBottom: `1px solid ${C.border}` },
}));

// ─── Stat Card ────────────────────────────────────────────────────────────────
const StatCard = ({ label, value, highlight }) => (
  <Box sx={{
    bgcolor:      highlight ? C.accent : C.white,
    border:       `1px solid ${highlight ? C.accent : C.border}`,
    borderRadius: '12px', p: 2.5,
    width: 160, minWidth: 160, height: 120, minHeight: 120,
    boxShadow:  highlight ? '0 4px 16px rgba(26,62,207,0.25)' : C.shadow,
    flexShrink: 0,
    display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
  }}>
    <Typography sx={{ fontSize: '11px', fontWeight: 500, color: highlight ? 'rgba(255,255,255,0.75)' : C.textMuted, letterSpacing: '0.06em', textTransform: 'uppercase', fontFamily: "'DM Sans',sans-serif" }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize: '26px', fontWeight: 700, color: highlight ? '#fff' : C.text, fontFamily: "'DM Sans',sans-serif", lineHeight: 1.2 }}>
      {value != null ? String(value) : '—'}
    </Typography>
    {highlight && <Box sx={{ height: '3px', width: '40px', bgcolor: '#F79009', borderRadius: '2px' }} />}
  </Box>
);

// ─── Action Button ────────────────────────────────────────────────────────────
const ActionBtn = ({ icon, label, onClick, primary, disabled }) => (
  <Button onClick={onClick} disabled={disabled} startIcon={icon} size="small"
    sx={{
      fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: '13px',
      borderRadius: '8px', textTransform: 'none', px: '14px', py: '7px',
      ...(primary
        ? { bgcolor: C.accent, color: '#fff', border: 'none', boxShadow: '0 2px 8px rgba(26,62,207,0.25)', '&:hover': { bgcolor: C.accentDark } }
        : { bgcolor: C.white, color: C.text, border: `1px solid ${C.border}`, '&:hover': { bgcolor: C.bg, borderColor: C.accent, color: C.accent } }
      ),
    }}
  >
    {label}
  </Button>
);

// ─── Phone Cell ───────────────────────────────────────────────────────────────
const PhoneCell = ({ user }) => {
  const [show,   setShow]   = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(user.phone || '').then(() => {
      setCopied(true);
      Notify('success', 'Phone copied!', 'success');
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Box onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <Typography sx={{ fontSize: '13px', color: copied ? C.success : C.text, mb: '4px', fontFamily: "'DM Sans',sans-serif" }}>
        {show ? user.phone : `${(user.phone || '').substring(0, 6)}···`}
      </Typography>
      <Box sx={{ display: 'flex', gap: '6px' }}>
        <IconButton size="small"
          onClick={e => { e.stopPropagation(); window.open(`https://wa.me/${(user.phone || '').replace(/\D/g, '')}`, '_blank'); }}
          sx={{ width: 26, height: 26, bgcolor: 'rgba(37,211,102,0.1)', color: '#25D366', borderRadius: '7px', '&:hover': { bgcolor: 'rgba(37,211,102,0.2)' } }}>
          <WhatsAppIcon sx={{ fontSize: 14 }} />
        </IconButton>
        <IconButton size="small"
          onClick={e => { e.stopPropagation(); window.open(`tel:${user.phone}`); }}
          sx={{ width: 26, height: 26, bgcolor: C.accentSoft, color: C.accent, borderRadius: '7px', '&:hover': { bgcolor: 'rgba(26,62,207,0.15)' } }}>
          <PhoneIcon sx={{ fontSize: 14 }} />
        </IconButton>
        <IconButton size="small" onClick={handleCopy}
          sx={{ width: 26, height: 26, bgcolor: copied ? C.successSoft : 'rgba(247,144,9,0.08)', color: copied ? C.success : C.warning, borderRadius: '7px' }}>
          {copied ? <CheckCircleIcon sx={{ fontSize: 14 }} /> : <ContentCopyIcon sx={{ fontSize: 14 }} />}
        </IconButton>
      </Box>
    </Box>
  );
};

// ─── Stage Cell — exact same logic as All_Leads_For_Sales_Page ───────────────
const StageCell = ({ lead }) => {
  const stageName   = lead.stage?.name || '';
  const isOverdue   = lead.stagedateupdated && moment(lead.stagedateupdated).isBefore(moment());
  const circleColor = isOverdue ? '#CC5500' : C.accent;

  const getBadgeStyle = (name) => {
    switch (name) {
      case 'Done Deal':      return { bg: 'rgba(18,183,106,0.10)',  color: '#12B76A' };
      case 'Pending':        return { bg: 'rgba(156,39,176,0.08)', color: '#9c27b0' };
      case 'Transfer':       return { bg: 'rgba(240,68,56,0.08)',  color: '#F04438' };
      case 'Not Interested': return { bg: 'rgba(85,85,85,0.08)',   color: '#555555' };
      case 'Fresh':          return { bg: 'rgba(76,175,80,0.08)',  color: '#4caf50' };
      case 'EOI':            return { bg: 'rgba(156,39,176,0.08)', color: '#9c27b0' };
      case 'Reservation':    return { bg: 'rgba(156,39,176,0.08)', color: '#9c27b0' };
      case 'No Answer':      return {
        bg:    isOverdue ? 'rgba(204,85,0,0.10)'  : 'rgba(255,107,53,0.08)',
        color: isOverdue ? '#CC5500'              : '#FF6B35',
      };
      default: return {
        bg:    isOverdue ? 'rgba(204,85,0,0.10)'  : C.accentSoft,
        color: isOverdue ? '#CC5500'              : C.accent,
      };
    }
  };

  const badge = getBadgeStyle(stageName);

  const renderIcon = () => {
    switch (stageName) {
      case 'Done Deal':
        return <span style={{ fontSize: '18px', lineHeight: 1 }}>🎉</span>;
      case 'Pending':
        return <SevereColdIcon sx={{ color: '#9c27b0', fontSize: '18px', flexShrink: 0 }} />;
      case 'Fresh':
        return <CheckIcon sx={{ fontSize: '18px', color: '#4caf50', flexShrink: 0 }} />;
      case 'Not Interested':
        return (
          <Box sx={{ width: 18, height: 18, borderRadius: '50%', bgcolor: '#555', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '12px', fontWeight: 700, flexShrink: 0, lineHeight: 1 }}>
            —
          </Box>
        );
      case 'EOI':
        return <EditNoteIcon sx={{ color: '#9c27b0', fontSize: '18px', flexShrink: 0 }} />;
      case 'Reservation':
        return <AssignmentTurnedInIcon sx={{ color: '#9c27b0', fontSize: '18px', flexShrink: 0 }} />;
      case 'Transfer':
        return <TransferWithinAStationIcon sx={{ color: '#F04438', fontSize: '18px', flexShrink: 0 }} />;
      case 'No Answer':
        return <Box sx={{ width: 18, height: 18, borderRadius: '50%', bgcolor: circleColor, flexShrink: 0 }} />;
      default:
        return <Box sx={{ width: 18, height: 18, borderRadius: '50%', bgcolor: circleColor, flexShrink: 0 }} />;
    }
  };

  if (!stageName) return null;

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: lead.stagedateupdated ? '4px' : 0 }}>
        {renderIcon()}
        <Box sx={{
          display: 'inline-flex', alignItems: 'center',
          px: '8px', py: '3px', borderRadius: '20px',
          bgcolor: badge.bg, color: badge.color,
        }}>
          <Typography sx={{ fontSize: '11.5px', fontWeight: 600, fontFamily: "'DM Sans',sans-serif", whiteSpace: 'nowrap' }}>
            {stageName}
          </Typography>
        </Box>
      </Box>

      {lead.stagedateupdated && (
        <Typography sx={{ fontSize: '10.5px', color: C.textMuted, fontFamily: "'DM Sans',sans-serif", display: 'flex', alignItems: 'center', gap: '3px' }}>
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
          </svg>
          {moment(lead.stagedateupdated).format('DD/MM/YY HH:mm')}
        </Typography>
      )}
    </Box>
  );
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
const getInitials = (n = '') =>
  (n || '').split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2) || '?';

// ─── Default Columns ──────────────────────────────────────────────────────────
const DEFAULT_COLS = [
  { key: 'name',      label: 'Name',          w: 200, visible: true },
  { key: 'phone',     label: 'Phone',         w: 150, visible: true },
  { key: 'project',   label: 'Project',       w: 160, visible: true },
  { key: 'developer', label: 'Developer',     w: 130, visible: true },
  { key: 'campaign',  label: 'Campaign',      w: 150, visible: true },
  { key: 'stage',     label: 'Stage',         w: 200, visible: true },
  { key: 'createdAt', label: 'Creation Date', w: 150, visible: true },
  { key: 'actions',   label: 'Actions',       w: 240, visible: true },
];

// ─── Main Component ───────────────────────────────────────────────────────────
export const SalesAllLeadsCRMDATA = () => {
  const theme    = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch  = useDispatch();
  const location  = useLocation();
  const sidebarW  = useSidebarWidth();

  const [userlogin, setUserlogin] = useState(null);
  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  // ── Redux ──────────────────────────────────────────────────────────────────
  const leadsFromRedux = useSelector(s => s.AllRoleData.LeadsForSales);
  const resproject     = useSelector(s => s.AllProjects.Projects);
  const salesdata      = useSelector(s => s.AllSales.sales_Assign_Leads_To_hisTeamLeader);
  const resupdatelead  = useSelector(s => s.Allusers.Get_users);

  // ── State ──────────────────────────────────────────────────────────────────
  const [loading,        setLoading]        = useState(true);
  const [currentPage,    setCurrentPage]    = useState(1);
  const [itemsPerPage,   setItemsPerPage]   = useState(25);
  const [searchQuery,    setSearchQuery]    = useState(localStorage.getItem('searchsalesuserstorage') || '');
  const [selectedLeads,  setSelectedLeads]  = useState([]);
  const [selectedLead,   setSelectedLead]   = useState(null);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [sortConfig,     setSortConfig]     = useState({ key: null, direction: 'ascending' });

  const [colConfig, setColConfig] = useState(() => {
    try { const s = localStorage.getItem('crmColConfig'); return s ? JSON.parse(s) : DEFAULT_COLS; }
    catch { return DEFAULT_COLS; }
  });
  useEffect(() => { localStorage.setItem('crmColConfig', JSON.stringify(colConfig)); }, [colConfig]);

  // modals
  const [quickFilter,       setQuickFilter]       = useState(false);
  const [settingsOpen,      setSettingsOpen]       = useState(false);
  const [requestDialogOpen, setRequestDialogOpen]  = useState(false);

  // receive
  const [showReceiveModal,       setShowReceiveModal]       = useState(false);
  const [selectedLeadForReceive, setSelectedLeadForReceive] = useState(null);
  const [receiveLoading,         setReceiveLoading]         = useState(false);

  // return to TL
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [loadingReturn,     setLoadingReturn]     = useState(true);

  // edit lead
  const [showUpdateLead,    setShowUpdateLead]    = useState(false);
  const [selectedLeadId,    setSelectedLeadId]    = useState(null);
  const [leadnameupdate,    setLeadnameupdate]    = useState('');
  const [phonenumber2,      setPhonenumber2]      = useState('');
  const [whatsappnumber,    setWhatsappnumber]    = useState('');
  const [projectupdatelead, setProjectupdatelead] = useState(null);
  const [loadingUpdate,     setLoadingUpdate]     = useState(true);
  const [loadingUpdate2,    setLoadingUpdate2]    = useState(false);

  // ── Col helpers ────────────────────────────────────────────────────────────
  const toggleColVisibility = (key) => setColConfig(p => p.map(c => c.key === key ? { ...c, visible: !c.visible } : c));
  const updateColWidth = (key, w) => setColConfig(p => p.map(c => c.key === key ? { ...c, w: Math.max(60, Math.min(400, parseInt(w) || c.w)) } : c));
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(colConfig);
    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);
    setColConfig(items);
  };

  // ── Data helpers ───────────────────────────────────────────────────────────
  const getLeadsArray = () => {
    if (!leadsFromRedux) return [];
    if (leadsFromRedux.data?.data && Array.isArray(leadsFromRedux.data.data)) return leadsFromRedux.data.data;
    if (leadsFromRedux.data && Array.isArray(leadsFromRedux.data)) return leadsFromRedux.data;
    if (Array.isArray(leadsFromRedux)) return leadsFromRedux;
    return [];
  };
  const getPagination = () => {
    if (!leadsFromRedux) return null;
    if (leadsFromRedux.data?.pagination) return leadsFromRedux.data.pagination;
    if (leadsFromRedux.pagination) return leadsFromRedux.pagination;
    return null;
  };

  // ── Fetch ──────────────────────────────────────────────────────────────────
  const loadLeads = async (page = 1, limit = itemsPerPage, search = searchQuery, filters = appliedFilters) => {
    if (!userlogin?.data?.email) return;
    setLoading(true);
    
     let processedSearchTerm = search;
  if (search && search.includes('+')) {
    processedSearchTerm = search.replace('+', '');
  }
    let q = `page=${page}&limit=${limit}&email=${encodeURIComponent(userlogin.data.email)}&data=false&transferefromdata=false`;
    const sp = new URLSearchParams(location.search);
    if (sp.get('stage'))          q += `&stage=${sp.get('stage')}`;
    // if (search?.trim())           q += `&keyword=${encodeURIComponent(search.trim())}`;
      if (processedSearchTerm?.trim()) q += `&keyword=${encodeURIComponent(processedSearchTerm.trim())}`;

    // if (filters.stage?.length)    filters.stage.forEach(s => { if (s?._id) q += `&stage=${s._id}`; });
    // if (filters.project?.length)  filters.project.forEach(p => { if (p?._id) q += `&project=${p._id}`; });
    // if (filters.campaign?.length) filters.campaign.forEach(c => { if (c?._id) q += `&campaign=${c._id}`; });
    // if (filters.createdAt?.from)  q += `&createdFrom=${encodeURIComponent(filters.createdAt.from)}`;
    // if (filters.createdAt?.to)    q += `&createdTo=${encodeURIComponent(filters.createdAt.to)}`;

    if (filters.stage?.length)    filters.stage.forEach(s => { if (s?._id) q += `&stage=${s._id}`; });
    if (filters.project?.length)  filters.project.forEach(p => { if (p?._id) q += `&project=${p._id}`; });
    if (filters.developer?.length) filters.developer.forEach(d => { if (d?._id) q += `&developer=${d._id}`; });
    if (filters.chanel?.length)   filters.chanel.forEach(c => { if (c?._id) q += `&channel=${c._id}`; });
    if (filters.campaign?.length) filters.campaign.forEach(c => { if (c?._id) q += `&campaign=${c._id}`; });
    if (filters.createdAt?.from)  q += `&createdFrom=${encodeURIComponent(filters.createdAt.from)}`;
    if (filters.createdAt?.to)    q += `&createdTo=${encodeURIComponent(filters.createdAt.to)}`;
    if (filters.stagedateupdated?.from) q += `&stageDateFrom=${encodeURIComponent(filters.stagedateupdated.from)}`;
    if (filters.stagedateupdated?.to)   q += `&stageDateTo=${encodeURIComponent(filters.stagedateupdated.to)}`;
    try { await dispatch(GetallLeads_data_With_Email2(userlogin.data.email, q)); }
    catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    if (userlogin?.data?.email) { loadLeads(); dispatch(GetallProjectsdata()); }
  }, [userlogin]);

  useEffect(() => {
    const handler = () => {
      const v = localStorage.getItem('searchsalesuserstorage') || '';
      setSearchQuery(v); setCurrentPage(1);
      loadLeads(1, itemsPerPage, v);
    };
    window.addEventListener('searchsalesuserstorageUpdate', handler);
    return () => window.removeEventListener('searchsalesuserstorageUpdate', handler);
  }, [userlogin, itemsPerPage]);

  // ── Sort ───────────────────────────────────────────────────────────────────
  const displayLeads = useMemo(() => {
  const arr = getLeadsArray();
  if (!arr.length || !sortConfig.key) return arr;
  return [...arr].sort((a, b) => {
    const get = l => {
      if (sortConfig.key === 'createdAt')        return new Date(l.date||0);
      if (sortConfig.key === 'stagedateupdated') return new Date(l.stagedateupdated||0);
      return 0;
    };
    const va = get(a), vb = get(b);
    return sortConfig.direction === 'ascending' ? va - vb : vb - va;
  });
}, [leadsFromRedux, sortConfig]);
  const pagination = getPagination();

  // ── Selection ──────────────────────────────────────────────────────────────
  const toggleLead = (id) => setSelectedLeads(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id]);
  const toggleAll  = () => {
    if (selectedLeads.length === displayLeads.length) setSelectedLeads([]);
    else setSelectedLeads(displayLeads.map(l => l._id));
  };

  // ── Receive ────────────────────────────────────────────────────────────────
  const handleReceiveLead = async () => {
    if (!selectedLeadForReceive) return;
    setReceiveLoading(true);
    try {
      await dispatch(UpdateClientActionToReaciveusertolead(selectedLeadForReceive._id, { assign: false }));
      Notify('success', 'Lead received successfully', 'success');
      setShowReceiveModal(false);
      setSelectedLeadForReceive(null);
      loadLeads(currentPage, itemsPerPage);
    } catch { Notify('error', 'Failed to receive lead', 'error'); }
    finally { setReceiveLoading(false); }
  };

  // ── Return to TL ───────────────────────────────────────────────────────────
  const handleReturnToTeamLeader = () => {
    if (!selectedLeads.length) { Notify('warning', 'Select at least one lead', 'warning'); return; }
    setConfirmDialogOpen(true);
  };
  const executeReturn = async () => {
    setLoadingReturn(true);
    try {
      await dispatch(Get_sales_Login_For_Assign_Leads_To_histeamleader_Action(selectedLeads, false));
      await loadLeads();
      setConfirmDialogOpen(false);
    } catch { Notify('error', 'Failed to return leads', 'error'); }
    finally { setLoadingReturn(false); }
  };
  useEffect(() => {
    if (!loadingReturn && salesdata?.status === 200) {
      Notify('success', 'Leads returned to Team Leader', 'success');
      setSelectedLeads([]);
    }
  }, [loadingReturn]);

  // ── Edit Lead ──────────────────────────────────────────────────────────────
  const handleShowUpdateLead = (lead) => {
    setSelectedLeadId(lead._id);
    setLeadnameupdate(lead.name || '');
    setPhonenumber2(lead.phonenumber2 || '');
    setWhatsappnumber(lead.whatsappnumber || '');
    setProjectupdatelead(lead.project ? (resproject?.data?.find(p => p._id === lead.project._id) || lead.project) : null);
    setShowUpdateLead(true);
  };
  const handleUpdateLead = async (e) => {
    e.preventDefault();
    if (!selectedLeadId || !leadnameupdate) return;
    setLoadingUpdate(true); setLoadingUpdate2(true);
    try {
      await dispatch(UpdateClientAction(selectedLeadId, { name: leadnameupdate, phonenumber2, whatsappnumber, project: projectupdatelead }));
    } catch { Notify('error', 'Failed to update lead', 'error'); }
    finally { setLoadingUpdate(false); setLoadingUpdate2(false); }
  };
  useEffect(() => {
    if (!loadingUpdate && resupdatelead?.status === 200) {
      Notify('success', 'Lead updated successfully', 'success');
      setShowUpdateLead(false);
      loadLeads();
    }
  }, [loadingUpdate]);

  const refresh = () => { setCurrentPage(1); setSelectedLeads([]); loadLeads(1, itemsPerPage); };

  // ── JSX ────────────────────────────────────────────────────────────────────
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Box sx={{
        ml: isMobile ? `${SIDEBAR_COLLAPSED}px` : `${sidebarW}px`,
        mt: '64px',
        minHeight: 'calc(100vh - 64px)',
        bgcolor: C.bg,
        transition: 'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)',
      }}>
        <Box sx={{ p: isMobile ? 2 : 3.5 }}>

          {/* ── Header ── */}
          <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 3 }}>
            <Box>
              <Typography sx={{ fontFamily: "'DM Sans',sans-serif", fontWeight: 800, fontSize: isMobile ? '28px' : '36px', color: C.text, lineHeight: 1.15, letterSpacing: '-0.02em' }}>
                My Leads<br />Center
              </Typography>
              <Typography sx={{ fontSize: '13.5px', color: C.textMuted, fontFamily: "'DM Sans',sans-serif", mt: 1 }}>
                Welcome back, <strong style={{ color: C.text }}>{userlogin?.data?.name || 'Sales'}</strong> — manage and track your assigned leads.
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'stretch' }}>
              <StatCard label="Total Leads"  value={pagination?.totalItems} />
              <StatCard label="Pages"        value={pagination?.NumberOfPages} />
              <StatCard label="Current Page" value={currentPage} />
              <StatCard label="Per Page"     value={itemsPerPage} highlight />
            </Box>
          </Box>

          {/* ── Table Card ── */}
          <Box sx={{ bgcolor: C.white, borderRadius: '12px', border: `1px solid ${C.border}`, boxShadow: C.shadow, overflow: 'hidden' }}>

            {/* Toolbar */}
            <Box sx={{ px: 2.5, py: 2, display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', borderBottom: `1px solid ${C.border}` }}>
              <Typography sx={{ fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: '16px', color: C.text, flex: 1 }}>
                Live Pipeline
              </Typography>

              <Tooltip title="Creation Date Newest first">
                <IconButton size="small"
                  onClick={() => setSortConfig({ key: 'createdAt', direction: 'descending' })}
                  sx={{ color: sortConfig.key === 'createdAt' && sortConfig.direction === 'descending' ? C.accent : C.textMuted, '&:hover': { color: C.accent } }}>
                  <ArrowDownwardIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Creation DateOldest first">
                <IconButton size="small"
                  onClick={() => setSortConfig({ key: 'createdAt', direction: 'ascending' })}
                  sx={{ color: sortConfig.key === 'createdAt' && sortConfig.direction === 'ascending' ? C.accent : C.textMuted, '&:hover': { color: C.accent } }}>
                  <ArrowUpwardIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              {/* <Tooltip title="Recent stage updates">
                <IconButton size="small"
                  onClick={() => setSortConfig({ key: 'stage', direction: 'descending' })}
                  sx={{ color: sortConfig.key === 'stage' ? C.accent : C.textMuted, '&:hover': { color: C.accent } }}>
                  <AccessTimeIcon fontSize="small" />
                </IconButton>
              </Tooltip> */}



<Tooltip title={
  sortConfig.key === 'stagedateupdated'
    ? (sortConfig.direction === 'descending' ? 'Stage: oldest first' : 'Stage: newest first')
    : 'Sort by stage date'
}>
  <IconButton size="small"
    onClick={() => setSortConfig(p => ({
      key: 'stagedateupdated',
      direction: p.key === 'stagedateupdated' && p.direction === 'descending' ? 'ascending' : 'descending',
    }))}
    sx={{ color: sortConfig.key === 'stagedateupdated' ? C.accent : C.textMuted, '&:hover': { color: C.accent } }}>
    <AccessTimeIcon fontSize="small" />
  </IconButton>
</Tooltip>

              {sortConfig.key && (
                <Tooltip title="Clear sort">
                  <IconButton size="small" onClick={() => setSortConfig({ key: null, direction: 'ascending' })} sx={{ color: C.textMuted, '&:hover': { color: C.danger } }}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}

              <Box sx={{ width: '1px', height: '20px', bgcolor: C.border }} />

              <Tooltip title="Quick Filter">
                <IconButton size="small" sx={{ color: C.textMuted, '&:hover': { color: C.accent } }} onClick={() => setQuickFilter(true)}>
                  <FilterListIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Refresh">
                <IconButton size="small" sx={{ color: C.textMuted, '&:hover': { color: C.accent } }} onClick={refresh} disabled={loading}>
                  <RefreshIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Table settings">
                <IconButton size="small" sx={{ color: C.textMuted, '&:hover': { color: C.accent } }} onClick={() => setSettingsOpen(true)}>
                  <SettingsIcon fontSize="small" />
                </IconButton>
              </Tooltip>

              <Box sx={{ width: '1px', height: '20px', bgcolor: C.border }} />

              <ActionBtn icon={<AddIcon />}                 label="New Lead"     primary onClick={() => { window.location.hash = '#/addclient'; }} />
              <ActionBtn icon={<RequestPageOutlinedIcon />} label="Request Data" onClick={() => setRequestDialogOpen(true)} />
            </Box>

            {/* Table */}
            <TableContainer sx={{ overflowX: 'auto' }}>
              <Table size="small" sx={{ minWidth: 700 }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: 52, minWidth: 52, py: '10px', px: '12px', borderBottom: `2px solid ${C.border}` }}>
                      <Checkbox size="small"
                        checked={selectedLeads.length === displayLeads.length && displayLeads.length > 0}
                        indeterminate={selectedLeads.length > 0 && selectedLeads.length < displayLeads.length}
                        onChange={toggleAll}
                        sx={{ color: C.textMuted }}
                      />
                    </TableCell>
                    {colConfig.filter(c => c.visible).map(col => (
                      <TableCell key={col.key}
                        onClick={col.key === 'createdAt' || col.key === 'stagedateupdated'
  ? () => setSortConfig(p => ({ key: col.key, direction: p.key === col.key && p.direction === 'ascending' ? 'descending' : 'ascending' }))
  : undefined}
                        sx={{
                          width: col.w, minWidth: col.w, py: '10px', px: '12px',
                          fontFamily: "'DM Sans',sans-serif", fontSize: '11.5px', fontWeight: 600,
                          color: C.textMuted, letterSpacing: '0.05em', textTransform: 'uppercase',
                          borderBottom: `2px solid ${C.border}`, whiteSpace: 'nowrap',
                       cursor: col.key === 'createdAt' || col.key === 'stagedateupdated' ? 'pointer' : 'default',
'&:hover': col.key === 'createdAt' || col.key === 'stagedateupdated' ? { color: C.accent } : {},
                        }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          {col.label}
                          {(col.key === 'createdAt' || col.key === 'stagedateupdated') && (
                            <Box sx={{ display: 'flex', flexDirection: 'column', opacity: sortConfig.key === col.key ? 1 : 0.3 }}>
                              <ArrowUpwardIcon sx={{ fontSize: 10, color: sortConfig.key === col.key && sortConfig.direction === 'ascending' ? C.accent : 'inherit', mb: '-3px' }} />
                              <ArrowDownwardIcon sx={{ fontSize: 10, color: sortConfig.key === col.key && sortConfig.direction === 'descending' ? C.accent : 'inherit' }} />
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={colConfig.filter(c => c.visible).length + 1} align="center" sx={{ py: 6 }}>
                        <CircularProgress size={32} sx={{ color: C.accent }} />
                      </TableCell>
                    </TableRow>
                  ) : !displayLeads.length ? (
                    <TableRow>
                      <TableCell colSpan={colConfig.filter(c => c.visible).length + 1} align="center" sx={{ py: 6 }}>
                        <Typography sx={{ color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>No leads found</Typography>
                      </TableCell>
                    </TableRow>
                  ) : displayLeads.map(lead => (
                    <StyledRow key={lead._id}>
                      <TableCell sx={{ px: '12px', py: '10px' }}>
                        <Checkbox size="small" checked={selectedLeads.includes(lead._id)} onChange={() => toggleLead(lead._id)}
                          sx={{ color: C.textMuted, '&.Mui-checked': { color: C.accent } }} />
                      </TableCell>

                      {/* Name */}
                      {colConfig.find(c => c.key === 'name')?.visible && (
                        <TableCell sx={{ px: '12px', cursor: 'pointer' }} onClick={() => setSelectedLead(lead)}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Avatar sx={{ width: 34, height: 34, fontSize: '12px', fontWeight: 700, bgcolor: C.accentSoft, color: C.accent, fontFamily: "'DM Sans',sans-serif" }}>
                              {getInitials(lead.name)}
                            </Avatar>
                            <Box>
                              <Typography sx={{ fontSize: '13.5px', fontWeight: 600, color: C.text, fontFamily: "'DM Sans',sans-serif", lineHeight: 1.3 }}>{lead.name}</Typography>
                              <Typography sx={{ fontSize: '12px', color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>{lead.email}</Typography>
                            </Box>
                          </Box>
                        </TableCell>
                      )}

                      {/* Phone */}
                      {colConfig.find(c => c.key === 'phone')?.visible && (
                        <TableCell sx={{ px: '12px' }}><PhoneCell user={lead} /></TableCell>
                      )}

                      {/* Project */}
                      {colConfig.find(c => c.key === 'project')?.visible && (
                        <TableCell sx={{ px: '12px' }}>
                          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: C.text, fontFamily: "'DM Sans',sans-serif" }}>{lead.project?.name || '—'}</Typography>
                        </TableCell>
                      )}

                      {/* Developer */}
                      {colConfig.find(c => c.key === 'developer')?.visible && (
                        <TableCell sx={{ px: '12px' }}>
                          <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>
                            {lead.developer?.name || lead.project?.developer?.name || '—'}
                          </Typography>
                        </TableCell>
                      )}

                      {/* Campaign */}
                      {colConfig.find(c => c.key === 'campaign')?.visible && (
                        <TableCell sx={{ px: '12px' }}>
                          <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>{lead.campaign?.CampainName || '—'}</Typography>
                          {lead.campaign?.redirectLink && (
                            <Box sx={{ display: 'flex', gap: '4px', mt: '4px' }}>
                              <IconButton size="small"
                                onClick={e => { e.stopPropagation(); navigator.clipboard.writeText(lead.campaign.redirectLink); Notify('success', 'Link copied', 'success'); }}
                                sx={{ width: 20, height: 20, color: C.textMuted, '&:hover': { color: C.accent } }}>
                                <ContentCopyIcon sx={{ fontSize: '13px' }} />
                              </IconButton>
                              <IconButton size="small"
                                onClick={e => { e.stopPropagation(); window.open(lead.campaign.redirectLink, '_blank'); }}
                                sx={{ width: 20, height: 20, color: C.textMuted, '&:hover': { color: C.accent } }}>
                                <OpenInNewIcon sx={{ fontSize: '13px' }} />
                              </IconButton>
                            </Box>
                          )}
                        </TableCell>
                      )}

                      {/* ✅ Stage — same logic as All_Leads_For_Sales_Page */}
                      {colConfig.find(c => c.key === 'stage')?.visible && (
                        <TableCell sx={{ px: '12px' }}><StageCell lead={lead} /></TableCell>
                      )}

                      {/* Creation Date */}
                      {colConfig.find(c => c.key === 'createdAt')?.visible && (
                        <TableCell sx={{ px: '12px' }}>
                          {lead.resetcreationdate ? (
                            <Typography sx={{ fontSize: '12px', color: C.textMuted, fontFamily: "'DM Sans',sans-serif", fontStyle: 'italic' }}>Not available</Typography>
                          ) : (
                            <>
                              <Typography sx={{ fontSize: '13px', color: C.text, fontFamily: "'DM Sans',sans-serif", fontWeight: 500 }}>
                                {lead.date ? moment(lead.date).format('DD/MM/YY') : '—'}
                              </Typography>
                              <Typography sx={{ fontSize: '11px', color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>
                                {lead.date ? moment(lead.date).format('HH:mm') : ''}
                              </Typography>
                            </>
                          )}
                        </TableCell>
                      )}

                      {/* Actions */}
                      {colConfig.find(c => c.key === 'actions')?.visible && (
                        <TableCell sx={{ px: '12px' }}>
                          <Box sx={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                            {/* Receive */}
                            <Tooltip title={lead.assign ? 'Receive lead' : 'Already received'}>
                              <span>
                                <Button size="small" disabled={!lead.assign}
                                  onClick={() => { setSelectedLeadForReceive(lead); setShowReceiveModal(true); }}
                                  sx={{
                                    fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: '12px',
                                    borderRadius: '7px', textTransform: 'none', px: '10px', py: '5px',
                                    bgcolor: lead.assign ? C.warning : C.border,
                                    color:   lead.assign ? '#fff' : C.textMuted,
                                    border: 'none', position: 'relative',
                                    '&:hover': { bgcolor: lead.assign ? '#e68a00' : C.border },
                                    '&.Mui-disabled': { bgcolor: '#F1F3F9', color: C.textMuted },
                                  }}>
                                  {lead.assign ? 'Receive' : 'Received'}
                                  {lead.assign && (
                                    <Box sx={{ position: 'absolute', top: 2, right: 2, width: 6, height: 6, borderRadius: '50%', bgcolor: C.danger, border: '1px solid #fff' }} />
                                  )}
                                </Button>
                              </span>
                            </Tooltip>

                            {/* Edit */}
                            <Button size="small" onClick={() => handleShowUpdateLead(lead)}
                              sx={{ fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: '12px', borderRadius: '7px', textTransform: 'none', px: '10px', py: '5px', bgcolor: C.white, color: C.text, border: `1px solid ${C.border}`, '&:hover': { borderColor: C.accent, color: C.accent, bgcolor: C.accentSoft } }}>
                              Edit
                            </Button>
                          </Box>
                        </TableCell>
                      )}
                    </StyledRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Pagination */}
            {!loading && displayLeads.length > 0 && (
              <Box sx={{ px: 2.5, py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'center', borderTop: `1px solid ${C.border}`, flexWrap: 'wrap', gap: 1.5, bgcolor: C.bg, position: 'fixed', bottom: 0, borderRadius: '0px 25px 25px 0px', zIndex: 10, boxShadow: '0 -2px 8px rgba(16,24,40,0.06)' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans',sans-serif", whiteSpace: 'nowrap' }}>Rows per page:</Typography>
                  <TextField select value={itemsPerPage}
                    onChange={e => { setItemsPerPage(e.target.value); setCurrentPage(1); loadLeads(1, e.target.value); }}
                    size="small" sx={{ width: 72, '& .MuiOutlinedInput-root': { borderRadius: '8px', fontSize: '13px' } }}>
                    {[10, 25, 50, 100].map(n => (
                      <MenuItem key={n} value={n} sx={{ fontFamily: "'DM Sans',sans-serif", fontSize: '13px' }}>{n}</MenuItem>
                    ))}
                  </TextField>
                </Box>
                <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>
                  Showing{' '}
                  <Box component="span" sx={{ fontWeight: 700, color: C.text }}>{displayLeads.length}</Box>
                  {' '}of{' '}
                  <Box component="span" sx={{ fontWeight: 700, color: C.text }}>{pagination?.totalItems || displayLeads.length}</Box>
                </Typography>
                {pagination?.NumberOfPages > 1 && (
                  <Pagination
                    count={pagination.NumberOfPages} page={currentPage} size="small" showFirstButton showLastButton
                    onChange={(_, v) => { setCurrentPage(v); loadLeads(v, itemsPerPage); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                    sx={{
                      '& .MuiPaginationItem-root': { fontFamily: "'DM Sans',sans-serif", fontSize: '13px', borderRadius: '6px', color: C.textMuted },
                      '& .Mui-selected': { bgcolor: `${C.accent} !important`, color: '#fff', fontWeight: 700 },
                      '& .MuiPaginationItem-root:hover': { bgcolor: C.accentSoft },
                    }}
                  />
                )}
              </Box>
            )}
          </Box>
        </Box>

        {/* ── Snackbar Bulk Actions ── */}
        <Snackbar
          open={selectedLeads.length > 0}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          message={`${selectedLeads.length} lead(s) selected`}
          action={
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Tooltip title="Return to Team Leader">
                <IconButton size="small" onClick={handleReturnToTeamLeader} sx={{ color: '#fbbf24' }}>
                  <ReplyIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Button size="small" onClick={() => setSelectedLeads([])} sx={{ color: '#fff', fontSize: '12px' }}>Clear</Button>
            </Box>
          }
        />

        {/* ── Modals ── */}
        {/* {selectedLead && (
          <ShowClientsActionsAdvanced user={selectedLead} leadid={selectedLead._id} onClose={() => setSelectedLead(null)} />
        )} */}

             {selectedLead && (
          <ShowClientsActionsAdvanced
            user={selectedLead}
            leadid={selectedLead._id}
            onClose={() => setSelectedLead(null)}
            onLeadUpdated={() => loadLeads(currentPage, itemsPerPage)}
          />
        )}

        
        <SalesQuickFilterModal
          open={quickFilter}
          onClose={() => setQuickFilter(false)}
          onApplyFilters={f => { setAppliedFilters(f); setCurrentPage(1); loadLeads(1, itemsPerPage, searchQuery, f); }}
          initialFilters={appliedFilters}
        />
        <SalesRequestData_Model open={requestDialogOpen} onClose={() => setRequestDialogOpen(false)} />

        {/* ── Confirm Return Dialog ── */}
        <Dialog open={confirmDialogOpen} onClose={() => setConfirmDialogOpen(false)} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}>
          <DialogTitle sx={{ fontFamily: "'DM Sans',sans-serif", fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            Return {selectedLeads.length} lead(s) to Team Leader?
            <IconButton onClick={() => setConfirmDialogOpen(false)} size="small"><CloseIcon fontSize="small" /></IconButton>
          </DialogTitle>
          <DialogContent>
            <Alert severity="warning">This action cannot be undone.</Alert>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 3 }}>
            <Button onClick={() => setConfirmDialogOpen(false)}>Cancel</Button>
            <Button variant="contained" sx={{ bgcolor: C.warning, '&:hover': { bgcolor: '#e68a00' } }} onClick={executeReturn}>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

        {/* ── Receive Lead Dialog ── */}
        <Dialog open={showReceiveModal} onClose={() => { setShowReceiveModal(false); setSelectedLeadForReceive(null); }} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}>
          <DialogTitle sx={{ bgcolor: C.accent, color: '#fff', fontFamily: "'DM Sans',sans-serif", fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            Receive Lead
            <IconButton onClick={() => { setShowReceiveModal(false); setSelectedLeadForReceive(null); }} sx={{ color: '#fff' }}><CloseIcon /></IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            {selectedLeadForReceive && (
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, p: 2, bgcolor: C.accentSoft, borderRadius: '10px' }}>
                  <Avatar sx={{ width: 48, height: 48, bgcolor: C.accent, fontFamily: "'DM Sans',sans-serif", fontWeight: 700 }}>
                    {getInitials(selectedLeadForReceive.name)}
                  </Avatar>
                  <Box>
                    <Typography sx={{ fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: '16px', color: C.text }}>{selectedLeadForReceive.name}</Typography>
                    {selectedLeadForReceive.phone && (
                      <Typography sx={{ fontFamily: "'DM Sans',sans-serif", fontSize: '13px', color: C.textMuted }}>{selectedLeadForReceive.phone}</Typography>
                    )}
                  </Box>
                </Box>
                <Alert severity="info">By receiving this lead, you take full responsibility for following up.</Alert>
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 3 }}>
            <Button onClick={() => { setShowReceiveModal(false); setSelectedLeadForReceive(null); }}>Cancel</Button>
            <Button variant="contained" onClick={handleReceiveLead} disabled={receiveLoading} sx={{ bgcolor: C.accent, '&:hover': { bgcolor: C.accentDark } }}>
              {receiveLoading ? <CircularProgress size={16} color="inherit" /> : 'Receive Lead'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* ── Edit Lead Dialog ── */}
        <Dialog open={showUpdateLead} onClose={() => setShowUpdateLead(false)} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}>
          <DialogTitle sx={{ fontFamily: "'DM Sans',sans-serif", fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <EditNoteIcon sx={{ color: C.accent }} />
              Edit Lead
            </Box>
            <IconButton onClick={() => setShowUpdateLead(false)} size="small"><CloseIcon fontSize="small" /></IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, mt: 1 }}>
              <TextField fullWidth label="Lead Name *" value={leadnameupdate || ''} onChange={e => setLeadnameupdate(e.target.value)}
                size="small" error={!leadnameupdate} helperText={!leadnameupdate ? 'Required' : ''}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }} />
              <Box>
                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: C.textMuted, mb: 1, fontFamily: "'DM Sans',sans-serif" }}>Phone 2 (optional)</Typography>
                <PhoneInput country="ae" value={phonenumber2 || ''} onChange={v => setPhonenumber2(v)}
                  preferredCountries={['ae', 'sa', 'qa']} enableSearch
                  inputStyle={{ width: '100%', borderRadius: '8px', fontSize: '13px' }} />
              </Box>
              <Box>
                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: C.textMuted, mb: 1, fontFamily: "'DM Sans',sans-serif" }}>WhatsApp (optional)</Typography>
                <PhoneInput country="ae" value={whatsappnumber || ''} onChange={v => setWhatsappnumber(v)}
                  preferredCountries={['ae', 'sa', 'qa']} enableSearch
                  inputStyle={{ width: '100%', borderRadius: '8px', fontSize: '13px' }} />
              </Box>
              {resproject?.data && (
                <Autocomplete
                  options={resproject.data}
                  getOptionLabel={o => o.name || ''}
                  value={projectupdatelead || null}
                  onChange={(_, v) => setProjectupdatelead(v)}
                  isOptionEqualToValue={(o, v) => o._id === v?._id}
                  renderInput={params => (
                    <TextField {...params} label="Project *" size="small"
                      error={!projectupdatelead} helperText={!projectupdatelead ? 'Required' : ''}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }} />
                  )}
                />
              )}
            </Box>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 3 }}>
            <Button onClick={() => setShowUpdateLead(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleUpdateLead}
              disabled={loadingUpdate2 || !leadnameupdate || !projectupdatelead}
              sx={{ bgcolor: C.accent, '&:hover': { bgcolor: C.accentDark } }}>
              {loadingUpdate2 ? <CircularProgress size={16} color="inherit" /> : 'Save Changes'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* ── Settings Drawer ── */}
        <Drawer anchor="right" open={settingsOpen} onClose={() => setSettingsOpen(false)}
          PaperProps={{ sx: { width: 360, bgcolor: '#F4F6FB !important', display: 'flex', flexDirection: 'column' } }}>
          <Box sx={{ px: 2.5, py: 2, bgcolor: C.white, borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton onClick={() => setSettingsOpen(false)} size="small"><CloseIcon fontSize="small" /></IconButton>
            <Typography sx={{ fontWeight: 700, fontSize: '17px', fontFamily: "'DM Sans',sans-serif", color: C.text, flex: 1 }}>Column Settings</Typography>
          </Box>
          <Box sx={{ flex: 1, overflowY: 'auto', px: 2.5, pt: 2.5, pb: 3 }}>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="cols">
                {provided => (
                  <Box ref={provided.innerRef} {...provided.droppableProps} sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {colConfig.map((col, index) => (
                      <Draggable key={col.key} draggableId={col.key} index={index}>
                        {(provided, snapshot) => (
                          <Box ref={provided.innerRef} {...provided.draggableProps}
                            sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.5, bgcolor: snapshot.isDragging ? '#E8ECFF' : C.white, borderRadius: '14px', border: `1.5px solid ${snapshot.isDragging ? C.accent : C.border}`, boxShadow: snapshot.isDragging ? '0 8px 24px rgba(26,62,207,0.18)' : '0 1px 3px rgba(16,24,40,0.06)' }}>
                            <IconButton size="small" onClick={() => toggleColVisibility(col.key)}
                              sx={{ width: 34, height: 34, borderRadius: '50%', color: col.visible ? C.accent : C.textMuted, bgcolor: col.visible ? C.accentSoft : 'rgba(123,130,154,0.08)' }}>
                              {col.visible ? <VisibilityIcon sx={{ fontSize: '17px' }} /> : <VisibilityOffIcon sx={{ fontSize: '17px' }} />}
                            </IconButton>
                            <Typography sx={{ flex: 1, fontSize: '14px', fontWeight: 600, color: col.visible ? C.text : C.textMuted, fontFamily: "'DM Sans',sans-serif", textDecoration: col.visible ? 'none' : 'line-through' }}>
                              {col.label}
                            </Typography>
                            <Box sx={{ width: 48, height: 36, bgcolor: '#F0F2F9', borderRadius: '8px', display: 'flex', alignItems: 'center' }}>
                              <input type="number" value={col.w}
                                onChange={e => updateColWidth(col.key, e.target.value)}
                                onClick={e => e.stopPropagation()}
                                style={{ width: '100%', height: '100%', border: 'none', outline: 'none', background: 'transparent', textAlign: 'center', fontSize: '13px', fontWeight: 600, color: C.text, fontFamily: "'DM Sans',sans-serif" }} />
                            </Box>
                            <Box {...provided.dragHandleProps} sx={{ display: 'flex', flexDirection: 'column', gap: '3px', cursor: 'grab', px: '2px' }}>
                              {[0, 1, 2].map(r => (
                                <Box key={r} sx={{ display: 'flex', gap: '3px' }}>
                                  {[0, 1].map(c => <Box key={c} sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: C.textMuted, opacity: 0.6 }} />)}
                                </Box>
                              ))}
                            </Box>
                          </Box>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Box>
                )}
              </Droppable>
            </DragDropContext>
          </Box>
          <Box sx={{ px: 2.5, py: 2, borderTop: `1px solid ${C.border}`, bgcolor: C.white, display: 'flex', gap: 1 }}>
            <Button fullWidth variant="outlined" onClick={() => setColConfig(DEFAULT_COLS)}
              sx={{ borderColor: C.border, color: C.textMuted, fontFamily: "'DM Sans',sans-serif", textTransform: 'none', borderRadius: '10px' }}>
              Reset
            </Button>
            <Button fullWidth variant="contained" onClick={() => setSettingsOpen(false)}
              sx={{ bgcolor: C.accent, '&:hover': { bgcolor: C.accentDark }, textTransform: 'none', fontFamily: "'DM Sans',sans-serif", borderRadius: '10px' }}>
              Done
            </Button>
          </Box>
        </Drawer>
      </Box>
    </LocalizationProvider>
  );
};
